import axios from 'axios';

import {CUSTOMER_DOCUMENTS_API, DOCUMENTS_API} from 'api/routes';
import {QueryOptions, buildQueryOptions} from 'api/utils';
import JSDB, {ApiCall, NKTypeConvertor} from '../../fromKotlin/nk';
import {resolvePdfForcePrice} from '../../utils/agentPrintFlags';
import {isVariableConversionRate} from '../../utils/cofcFeatures';
import IItem from 'types/product_delivery';
import {
    dateObjectToString,
    dateObjectToStringIsrael,
    dateTimeObjectToString,
    roundDecimals
} from '../../fromKotlin/nkutils';
import {
    DocumentStatus,
    ExtendedDocument,
    ProductNote,
    DocumentType,
    docTypeToDocType, isSupplierDocument, docStatusToNum, displayDocumentId
} from 'types/DocumentsTypes/Document';
import {
    createDocument,
    deserializeCarteset,
    deserializeDetails,
    deserializeDocument,
    deserializePaymentsForBackend,
    documentTypes,
    Payment,
    serializePayment,
    toArrayOrEmpty,
    visitStates,
    visitStatesMap,
    applySupplierInputEquipment
} from 'types/DocumentsTypes/utils';
import {TaxNote} from 'types/DocumentsTypes/TaxNote';
import {PayNote} from '../../types/DocumentsTypes/PayNote';
import {CartesetDataHolder} from '../../types/CartesetDataHolder';
import {
    deserializeCustDataToClientDaily,
    deserializeDataStruct, deserializeDataStructOld,
    deserializeOrderDataToClientDaily,
    deserializeOrderDataToOrder,
    OrderData,
    orderKey
} from '../../types/OrderData';
import {OrderActiveState} from '../../types/OrderActiveState';
import {ICustomer} from '../../cdmanagment/src/types/customerStore-types';
import {AllTaxNoteHolder} from '../../types/AllTaxNoteHolder';
import {groupBy, groupByUnStr} from './analytics.api';
import {OrderManagment, RoutePlan} from "../../types/plannedVactuall";
import {distinct, distinctByField, distinctByFieldWithCount} from "../../utils/sort";
import {debtDataHolder} from "../../types/debtDataHolder";
import {optimizeClientIds, OptimizedClientRows} from './route_optimization.api';

export interface CustomerDocumentsQueryOptions extends QueryOptions {
    status?: DocumentStatus[];
    type?: DocumentType;
}

export const getDocuments: (opts?: CustomerDocumentsQueryOptions) => Promise<ExtendedDocument[]> = async (opts) => {
    const url = `${DOCUMENTS_API}${buildQueryOptions(opts)}`;
    const res = await axios.get(url);
    return res.data.documents.map((d) => createDocument({...d}));
};

export const getCustomerDocuments: (cid: string, opts?: CustomerDocumentsQueryOptions) => Promise<ExtendedDocument[]> = async (cid, opts) => {
    const url = `${CUSTOMER_DOCUMENTS_API(cid)}${buildQueryOptions(opts)}`;
    const res = await axios.get(url);
    return res.data.documents.map((d) => createDocument({...d}));
};

export const createCustomerDocument: (cid: string, d: Document) => Promise<ExtendedDocument> = async (cid, d) => {
    const res = await axios.post(CUSTOMER_DOCUMENTS_API(cid), d);
    return res.data.document;
};


// YOTAM

const rejectIfOrderSaveFailed = (req: ApiCall, result?: any, err?: any): Promise<never> => {
    const name = err?.name || err?.message || result?.second?.name || req.lastError?.() || '';
    if (String(name).includes('VERSION_CONFLICT')) {
        return Promise.reject(Object.assign(new Error('VERSION_CONFLICT'), { name: 'VERSION_CONFLICT' }));
    }
    return Promise.reject(err instanceof Error ? err : new Error(String(name || 'שגיאה בשמירה')));
};

const executeOrderSave = async (req: ApiCall) => {
    try {
        const result = await req.execute();
        if (result == null || result.second?.name !== 'SUCCESS') {
            return rejectIfOrderSaveFailed(req, result);
        }
        return result;
    } catch (e: any) {
        return rejectIfOrderSaveFailed(req, null, e);
    }
};

export const docResultsDeserialize: (ret: any) => ExtendedDocument[] = (ret) => {
    console.log(ret);
    if (ret.size > 0) {
        try {
        const result = ret.toArray().map((d) => deserializeDocument(d));
            console.log(result);
            return result;
        } catch (error) {
            console.log(error);
            return [];
        }
    }
    console.log("empty");
    return [];
};

export const getOrdersByIds: (orderIds: number[]) => Promise<ExtendedDocument[]> = async (orderIds) => {
    const ids = (orderIds || []).filter((id) => Number.isFinite(Number(id)) && Number(id) > 0);
    if (ids.length === 0) return [];
    const req = new ApiCall('GET_CLIENT_ORDER');
    req.putParam('order_ids', NKTypeConvertor().toKotlinList(ids));
    req.putParam('withoutInventory', true);
    const result = await req.execute();
    if (result == null || result.second.name !== 'SUCCESS') {
        return [];
    }
    return docResultsDeserialize(result.first);
};

export const getLastUpdatedOrdersForDate: (date: Date, actionTime: string) => Promise<ExtendedDocument[]> = async (date, actionTime) => {
    const req = new ApiCall('GET_LAST_UPDATED_ORDERS');
    req.putParam('date', dateObjectToString(date));
    req.putParam('action_time', actionTime);
    req.putParam('full', true);
    const result = await req.execute();
    if (result == null || result.second.name !== 'SUCCESS') {
        return [];
    }
    return docResultsDeserialize(result.first);
};

export const getBaseOrder: (day: number, client_id?: number[], full?: boolean) => Promise<ExtendedDocument[]> = async (day, client_id, full = undefined) => {
    const req = new ApiCall('GET_CLIENT_BASE_ORDER');
    if (client_id)
        req.putParam('client_ids', NKTypeConvertor().toKotlinList(client_id));
    req.putParam('day', day);
    if (full)
        req.putParam('full', full);
    const result = await req.execute();
    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    return docResultsDeserialize(result.first);

};
export const getClientPayments: (fromDate?: Date, toDate?: Date, cids?: number[], full?: boolean, paid?: boolean, sup?: boolean, dateIsDoc?: boolean) => Promise<ExtendedDocument[]> = async (fromDate, toDate, cids, full, paid, sup, dateIsDoc) => {
    const req = new ApiCall('GET_CLIENT_PAY_OPEN');
    if (cids)
        req.putParam('client_ids', NKTypeConvertor().toKotlinList(cids));
    if (fromDate)
        req.putParam('fromDate', JSDB().getDatesManipulator().dateIsrael(dateObjectToString(fromDate)));
    if (toDate)
        req.putParam('toDate', JSDB().getDatesManipulator().dateIsrael(dateObjectToString(toDate)));
    if (full)
        req.putParam('full', true);
    if (paid != undefined)
        req.putParam('paid', paid)
    if (sup != undefined)
        req.putParam('sup', sup)
    if (dateIsDoc != undefined)
        req.putParam('dateIsDoc', dateIsDoc)

    const result = await req.execute();
    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    return docResultsDeserialize(result.first);


}

/** Same as [getClientPayments] but filters by check number in `payment_data_raw` (server `/clients/pay`). */
export const getClientPaymentsByCheckNumber: (
    checkNumber: string,
    fromDate?: Date,
    toDate?: Date,
    full?: boolean,
    paid?: boolean,
    sup?: boolean,
    dateIsDoc?: boolean
) => Promise<ExtendedDocument[]> = async (checkNumber, fromDate, toDate, full, paid, sup, dateIsDoc) => {
    const trimmed = checkNumber?.trim();
    if (!trimmed) {
        return [];
    }
    const req = new ApiCall('GET_CLIENT_PAY_OPEN');
    req.putParam('check_number', trimmed);


    console.log(req);
    const result = await req.execute();
    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    return docResultsDeserialize(result.first);
};

export const getSpecificDocument: (type: DocumentType, cid?: number, fromDate?: Date, toDate?: Date, open?: boolean, specific?: number, full?: boolean, onlyProducts?: boolean, cids?: number[], branched?: boolean, api?: boolean, check_date?: Date, inventory?: boolean, check_date_from?: Date,statuses?:number,limit?:number) => Promise<ExtendedDocument[]> = async (type, cid = undefined, fromDate = undefined, toDate = undefined, open = undefined, specific = undefined, full = undefined, onlyProducts = undefined, cids = undefined, branched = undefined, api = undefined, check_date = undefined, inventory = undefined, check_date_from = undefined,statuses=undefined,limit=undefined) => {
    let req;
    if (type === 'delivery_certificate') {
        req = new ApiCall('GET_CLIENT_NOTE');
        // req.putParam("api",true)
        if (specific)
            req.putParam('id', Number(specific));
    } else if (type === 'invoice' || type === 'sup_invoice') {
        req = new ApiCall('GET_CLIENT_TAX_NOTE');
        if (specific)
            req.putParam('id', Number(specific));
        if (onlyProducts)
            req.putParam('withProduct', Number(1));
        if (type == 'sup_invoice')
            req.putParam('sup', true);
        req.putParam('type', Number(0));
    } else if (type === 'tax_invoice' || type === 'sup_tax_invoice') {
        req = new ApiCall('GET_CLIENT_TAX_NOTE');
        if (specific)
            req.putParam('id', Number(specific));
        if (onlyProducts)
            req.putParam('withProduct', Number(1));
        if (type == 'sup_tax_invoice')
            req.putParam('sup', true);
        if (check_date)
            req.putParam('check_date', (dateObjectToStringIsrael(check_date)));
        if (check_date_from)
            req.putParam('check_date_from', (dateObjectToString(check_date_from)));
        req.putParam('type', Number(1));
    } else if (type === 'refund' || type === 'sup_refund') {
        req = new ApiCall('GET_CLIENT_TAX_NOTE');
        if (specific)
            req.putParam('id', Number(specific));
        if (onlyProducts)
            req.putParam('withProduct', Number(1));
        if (type == 'sup_refund')
            req.putParam('sup', true);
        req.putParam('type', Number(2));
    } else if (type === 'order') {
        req = new ApiCall('GET_CLIENT_ORDER');
        if (open != undefined && open) {
            req.putParam('inverse_status', NKTypeConvertor().toKotlinList([2, 0, 13, 12, 16]));
        }
        if (specific)
            req.putParam('order_id', Number(specific));
        if (!inventory)
            req.putParam('withoutInventory', true);
        if(statuses){
            req.putParam('status',NKTypeConvertor().toKotlinList(statuses));
        }

    } else if (type === 'receipt' || type === 'sup_receipt') {
        req = new ApiCall('GET_CLIENT_PAY');
        if (specific)
            req.putParam('id', Number(specific));
        if (type == 'sup_receipt')
            req.putParam('sup', true);
        if (check_date)
            req.putParam('check_date', (dateObjectToString(check_date)));
        if (check_date_from)
            req.putParam('check_date_from', (dateObjectToString(check_date_from)));
    } else if (type === 'supplier_note') {

        req = new ApiCall('GET_SUPPLIER_NOTE');
        if (specific)
            req.putParam('delivery_id', Number(specific));
        if (cid)
            req.putParam('supplier_id', Number(cid));
        if (cids)
            req.putParam('client_ids', NKTypeConvertor().toKotlinList(cids));
    } else if (type === 'visit_note') {
        req = new ApiCall('GET_CLIENT_VISIT_NOTE');
        if (specific)
            req.putParam('ids', NKTypeConvertor().toKotlinList([Number(specific)]));
        if (cids)
            req.putParam('ent_ids', NKTypeConvertor().toKotlinList(cids));
    }
    if (api)
        req.putParam('api', true);
    if (branched)
        req.putParam('branched', true);
    if (cid)
        req.putParam('client_id', Number(cid));
    if (cids)
        req.putParam('client_ids', NKTypeConvertor().toKotlinList(cids));
    if (fromDate)
        req.putParam('fromDate', dateObjectToString(fromDate));
    if (toDate)
        req.putParam('toDate', dateObjectToString(toDate));
    if (full)
        req.putParam('full', true);
    if (limit)
        req.putParam('limit', limit);
    if (open !== undefined)
        req.putParam('open', open);
    console.log(req);
    const result = await req.execute();
    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });

    console.log(result);
    return docResultsDeserialize(result.first);

};
export const getAllSupplierDocuments: (fromDate: Date, toDate: Date, full?: boolean, cid?: string, tax_only?: boolean) => Promise<ExtendedDocument[]> = async (fromDate, toDate, full = undefined, cid = undefined, tax_only = undefined) => {

    const req = new ApiCall('GET_ALL_SPECIFIC_SUPPLIER_DOCUMENTS');
    if (cid)
        req.putParam('sup_id', Number(cid));
    req.putParam('fromDate', dateObjectToString(fromDate));
    req.putParam('toDate', dateObjectToString(toDate));
    if (tax_only)
        req.putParam('tax_only', true);
    if (full)
        req.putParam('full', true);
    req.putParam("api", false)
    const result = await req.execute();
    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    return docResultsDeserialize(result.first);

};

export const buildClientCartesetDebt: (toDate: Date, cids?: number[]) => Promise<boolean> = async (toDate, cids) => {

    const req = new ApiCall('OPTIMIZED_CARTESET_VALUE');
    if (cids)
        req.putParam('ids', NKTypeConvertor().toKotlinList(cids));
    req.putParam('toDate', dateObjectToString(toDate));

    const result = await req.execute();
    if (result == null || result.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    return true

};
export const getAllMsgTracker: (date: Date, limit?: number) => Promise<boolean> = async (date, limit) => {

    const req = new ApiCall('GET_MSG_TRACKER');
    if (limit)
        req.putParam('limit', limit);
    req.putParam('date_created', dateObjectToString(date));

    const result = await req.execute();


    return toArrayOrEmpty(result.first)

};


export const getAllCustomerDocuments: (fromDate: Date, toDate: Date, full?: boolean, cid?: string, apis?: boolean, tax_only?: boolean, onlyProducts?: boolean, driver?: number, visit?: boolean, client_ids?: number[], cost?: boolean, documents?: string[], product_ids?: number[]) => Promise<ExtendedDocument[]> = async (fromDate, toDate, full = undefined, cid = undefined, apis = undefined, tax_only = undefined, onlyProducts = undefined, driver = undefined, visit, client_ids, cost, documents, product_ids) => {

    const req = new ApiCall('GET_ALL_SPECIFIC_CLIENT_DOCUMENTS');
    if (cid)
        req.putParam('client_id', Number(cid));
    req.putParam('fromDate', dateObjectToString(fromDate));
    req.putParam('toDate', dateObjectToString(toDate));
    if (full)
        req.putParam('full', true);
    if (tax_only)
        req.putParam('tax_only', true);
    if (apis !== undefined)
        req.putParam('api', apis);
    if (cost)
        req.putParam('cost', true);
    if (onlyProducts)
        req.putParam('onlyProducts', true);
    if (driver != undefined)
        req.putParam('driver_id', driver);
    if (visit != undefined || documents?.some(d => d === 'visit_note'))
        req.putParam('visit', visit ?? documents?.some(d => d === 'visit_note'));
    if (client_ids != undefined && client_ids.length > 0)
        req.putParam('client_ids', NKTypeConvertor().toKotlinList(client_ids));
    if (documents && documents.length > 0) {
        req.putParam('force_documents', NKTypeConvertor().toKotlinList(docTypeToDocType(documents)));
    }
    if (product_ids != undefined && product_ids.length > 0)
        req.putParam('product_ids', NKTypeConvertor().toKotlinList(product_ids.map((id) => Number(id))));


    console.log(req);
    const result = await req.execute();
    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    return docResultsDeserialize(result.first);

};

/** Updates Product.cost_price from מחיר עלות קבוע only — never dated client_prices. */
export async function syncFixedProductCosts(items: IItem[]): Promise<void> {
    const byId = new Map<number, number>();
    items.forEach((row) => {
        if (row.fixedCostPrice == null || row.fixedCostPrice === undefined) return;
        const nk = JSDB().getClientProduct(row.id).first;
        if (!nk) return;
        const next = Number(row.fixedCostPrice);
        const prev = Number(nk.cost_price ?? 0);
        if (Math.abs(next - prev) < 0.00001) return;
        byId.set(row.id, next);
    });
    if (byId.size === 0) return;
    const { changeAllProducts } = await import('../products/customers.api');
    const { deserializeProduct } = await import('../../types/product');
    const products = [];
    byId.forEach((cost, id) => {
        const nk = JSDB().getClientProduct(id).first;
        if (!nk) return;
        products.push({ ...deserializeProduct(nk), cost_price: cost });
    });
    if (products.length > 0) {
        await changeAllProducts(products);
    }
}

export function collect(items: IItem[], id: number, client: boolean = true, usep: boolean, preserveExistingUsePrice: boolean = false): any[] {
    const pds: any[] = [];
    let entity: any;
    if (client)
        entity = JSDB().getClient(id).first;
    else
        entity = JSDB().getSupplier(id).first;
    items.forEach((row, index) => {
        const x: any = JSDB().createProductDelivery(row.id);
        x.isClient = client;

        x.value = row.quantity;
        x.returns = row.quantityReturns;
        if (row.quantitySecond)
            x.wrapped_amount = row.quantitySecond
        // order-only third unit (no conversion, never charged); left third_unit at its default (0)
        // so the backend falls back to the product's configured third-unit label (getThirdUnit()).
        if (row.quantityThird)
            x.third_amount = row.quantityThird
        const keepRate = isVariableConversionRate() || !(row.quantity > 0 && row.quantitySecond > 0);
        if (keepRate && row.conversion_ratio)
            x.conversion_ratio = row.conversion_ratio

        if (row.notes && row.notes != '') {
            x.notes = row.notes;
        }
        if (row.costPrice) {
            x.cost = row.costPrice;
        }
        if(row.isLocked)
            x.o_locked =1;
        if (row.notePlacement != undefined && row.notePlacement != null) {
            x.tempPosition = row.notePlacement;
        } else {
            x.tempPosition = index;
        }
        if (x.value !== 0 || x.returns !== 0 || x.wrapped_amount != 0 || x.third_amount != 0) {
            x.price = row.totalPrice;
            x.discount = row.discount;
            if (usep) {
                if (x.getProduct().getNoTaxProduct() === 1 || entity.no_tax_client == 1) {
                    x.use_price = 1;
                } else if (entity.getIncludeTax() === 0) {
                    x.use_price = 2;
                } else if (entity.getIncludeTax() === 1) {
                    x.use_price = 3;
                }
            } else if (preserveExistingUsePrice) {
                const existingUsePrice = Number(row.nkObject?.use_price ?? 0);
                if (existingUsePrice > 0) {
                    x.use_price = existingUsePrice;
                }
            }
            pds.push(x);
        }
    });
    return pds;
}

export const newClientDebt: (cid: number, date: Date, positive: number, negative: number, notes: string, sup?: boolean) => Promise<ExtendedDocument> = async (cid, date, positive, negative, notes, sup) => {
    let req: ApiCall;
    req = new ApiCall('NEW_CLIENT_CARTESET');
    req.putParam('date', dateObjectToString(date));
    req.putParam('positive', positive);
    req.putParam('negative', negative);
    req.putParam('id', Number(cid));
    req.putParam('notes', notes);
    if (sup)
        req.putParam('sup', true);
    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    return deserializeDocument(result.first);
    ;

};
export const getClientDebt: (cid: number, date: Date, sup?: boolean) => Promise<ExtendedDocument[]> = async (cid, date, sup) => {
    let req: ApiCall;
    req = new ApiCall('GET_CLIENT_CARTESET');
    req.putParam('fromDate', dateObjectToString(date));
    req.putParam('toDate', dateObjectToString(date));
    req.putParam('state', 0);
    req.putParam('id', Number(cid));
    if (sup)
        req.putParam('sup', true);
    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    return (result.first);
    ;

};


export const createDVFromPds: (cid: number, d: any[], date: Date, comment?: string) => Promise<ExtendedDocument> = async (cid, d, date, comment) => {
    let req: ApiCall;
    req = new ApiCall('NEW_CLIENT_NOTE');
    req.putParam('date', dateObjectToString(date));
    req.putParam('delivery_value', NKTypeConvertor().toKotlinList(d));
    req.putParam('agent', JSDB().currentAgent);
    req.putParam('ent_id', Number(cid));
    if (comment)
        req.putParam('notes', comment);
    req.putParam('date_issued', JSDB().getDatesManipulator().dateNow());


    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    return docResultsDeserialize(result.first);
    ;

};

export const createSupplierNote: (cid: string, d: ExtendedDocument) => Promise<ExtendedDocument> = async (cid, d) => {
    let req: ApiCall;
    req = new ApiCall('NEW_SUPPLIER_NOTE');
    const savePriceInNote = JSDB().getUser().first.savePriceInNote();
    const usePriceInNote = JSDB().getUser().first.needPriceInNoteShow();
    req.putParam('date', dateObjectToString(d.date));

    const products = d.products.sort((a, b) => (
        (a?.notePlacement != undefined || b?.notePlacement != undefined) ? ((a?.notePlacement ?? 0) - (b?.notePlacement ?? 0)) :
            (1))
    );
    req.putParam('delivery_value', NKTypeConvertor().toKotlinList(collect(products, Number(cid), false, savePriceInNote)));
    req.putParam('agent', JSDB().currentAgent);
    req.putParam('ent_id', Number(cid));
    req.putParam('with_price', usePriceInNote);
    if ((d as ProductNote).bul)
        req.putParam('connected_id', NKTypeConvertor().toKotlinLong((d as ProductNote).bul));

    req.putParam('notes', (d as ProductNote).comment);
    req.putParam('date_issued', JSDB().getDatesManipulator().dateNow());
    if ((d as ProductNote).notes2) {
        req.putParam('notes2', (d as ProductNote).notes2);
    }
    if ((d as ProductNote).notes3) {
        req.putParam('notes3', (d as ProductNote).notes3);
    }
    if ((d as ProductNote).notes4) {
        req.putParam('notes4', (d as ProductNote).notes4);
    }
    if ((d as ProductNote).notes5) {
        req.putParam('notes5', (d as ProductNote).notes5);
    }
    if (Number(d.id)) {
        req.putParam('delivery_id', Number(d.id));
    }
    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });

    return docResultsDeserialize(result.first);

};


/** Client-side Abort/timeout for a single tax-note create (ms). Large enough for slow nets; bulk uses per-client queue. */
export const TAX_NOTE_CREATE_TIMEOUT_MS = 90000;

export const createDvsTaxNoteSplitted: (dvs: number[], date: Date, splitBranch?: boolean, external_details?: string, doRound?: boolean, discount_percent?: number, allowZeroPrice?: boolean, timeoutMs?: number) => Promise<string[]> = async (dvs, date, splitBranch, external_details, doRound, discount_percent, allowZeroPrice, timeoutMs = TAX_NOTE_CREATE_TIMEOUT_MS) => {
    let req: ApiCall;

    req = new ApiCall('NEW_CLIENT_TAX_NOTE_BRANCH_SPLITTED');
    req.putParam('document_date', dateObjectToString(date));
    req.putParam('delivery_notes', NKTypeConvertor().toKotlinList(dvs));
    if (discount_percent != undefined)
        req.putParam('discount_percent', discount_percent);
    if (splitBranch)
        req.putParam('splitBranch', splitBranch);
    req.putParam('agent', JSDB().currentAgent);
    if (external_details)
        req.putParam('external_details', external_details);
    if (doRound)
        req.putParam('doRound', doRound);
    if (allowZeroPrice)
        req.putParam('allowZeroPrice', allowZeroPrice);

    let result;
    try {
        result = await req.execute(undefined, undefined, timeoutMs);
    } catch (e: any) {
        const msg = e?.message || e?.name || req.lastError?.() || 'שגיאה בהנפקת חשבונית';
        return Promise.reject(new Error(String(msg)));
    }

    if (result == null || result.second.name !== 'SUCCESS') {
        const msg = req.lastError?.() || result?.second?.name || 'שגיאה בהנפקת חשבונית';
        return Promise.reject(new Error(String(msg)));
    }
    if (result.first == null || result.first.size == 0)
        return []
    return result.first.toArray()

}

export function getOpenDeliveryNotesForTax(holder: AllTaxNoteHolder) {
    return (holder.sub ?? [])
        .filter((note) => note.status === 'open' && note.nkObject)
        .map((note) => note.nkObject);
}

export function getZeroPriceInvoiceWarnings(holder: AllTaxNoteHolder): string[] {
    const deliveryNotes = getOpenDeliveryNotesForTax(holder);
    if (deliveryNotes.length === 0) return [];
    try {
        const result = JSDB().allNotesWithPrice(NKTypeConvertor().toKotlinList(deliveryNotes));
        if (!result) return [];
        return typeof result.toArray === 'function' ? result.toArray() : Array.from(result);
    } catch {
        return [];
    }
}

export function formatZeroPriceWarningsHtml(warnings: string[]): string {
    if (!warnings.length) return '';
    const items = warnings.map((w) => `<li style="text-align:right">${w}</li>`).join('');
    return `<ul style="margin:12px 0;padding-right:20px;max-height:220px;overflow:auto">${items}</ul>`;
}

/**
 * Preview of a branch split: one row per invoice that will be issued, with the שם עוסק and
 * ח.פ it will actually carry. A member set to bill on its own ח.פ but lacking one is flagged,
 * because its invoice silently falls back to the network's identity.
 */
export function formatBranchSplitPreviewHtml(members: any[]): string {
    if (!members?.length) return '';
    const rows = members.map((c) => {
        const resolved = c?.buildStaticData?.();
        const fallsBack = c?.billsBranchIdentity?.() === true && c?.hasValidOwnBusinessIdentity?.() === false;
        const cell = 'text-align:right;padding:3px 8px;border-bottom:1px solid #eee';
        return `<tr>
            <td style="${cell}">${c?.getName?.() ?? ''}</td>
            <td style="${cell}">${resolved?.business_name ?? ''}</td>
            <td style="${cell}">${resolved?.business_id || '—'}</td>
            <td style="${cell};color:#c62828">${fallsBack ? 'ללא ח.פ עצמאי — יונפק על שם הרשת' : ''}</td>
        </tr>`;
    }).join('');
    const header = 'text-align:right;padding:3px 8px';
    return `<p style="text-align:right;margin-bottom:8px">יונפקו ${members.length} חשבוניות נפרדות:</p>
        <table style="width:100%;border-collapse:collapse;font-size:13px">
            <tr>
                <th style="${header}">סניף</th>
                <th style="${header}">שם עוסק</th>
                <th style="${header}">ח.פ</th>
                <th style="${header}"></th>
            </tr>
            ${rows}
        </table>`;
}

export const updateAmountsDocuments: (data: any[], savePriceInClient?: boolean, editList?: any[]) => Promise<ExtendedDocument[]> = async (data, savePriceInClient, editList) => {
    let req: ApiCall;

    req = new ApiCall('UPDATE_MASS_DOCUMENT');
    req.putParam('data', NKTypeConvertor().toKotlinList(data.map((d) => {
        const rate = (!isVariableConversionRate() && d.quantity > 0 && d.quantitySecond > 0) ? 0 : d.conversion_ratio
        const edit = editList?.find(e => e.id == d.id.toString())
        const cost = edit?.data?.costPrice != undefined ? d.costPrice : null
        return JSDB().createChangeNoteHelper(d.doc_id, d.note.nkObject.getConnectedDocType(), d.p_id, d.quantity, d.quantitySecond, rate, d.quantityReturns, d.totalPrice, d.discount, d.driver, dateObjectToString(d.date), cost)
    })));
    if (savePriceInClient)
        req.putParam('savePriceInClient', savePriceInClient);
    console.log(req)

    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    if (result.first.size == 0)
        return []

    return result.first.toArray().map(d => (deserializeDocument(d)))

}
/** Order id the web grid stores on the row (`orderId`) or on the document (`refId`). */
const linkedOrderIdOf = (d: any): number | undefined => {
    const raw = d?.refId ?? d?.orderId ?? d?.header?.order_id ?? d?.nkObject?.order_id;
    const n = Number(raw);
    return Number.isFinite(n) && n > 0 ? n : undefined;
};

export const createRealCustomerDocuments: (cid: string, d: ExtendedDocument) => Promise<ExtendedDocument> = async (cid, d) => {
    let req: ApiCall;
    let savePriceInNote = JSDB().getUser().first.savePriceInNote();
    const usePriceInNote = JSDB().getUser().first.needPriceInNoteShow();

    if (d.type === 'delivery_certificate') {
        req = new ApiCall('NEW_CLIENT_NOTE');
        req.putParam('date', dateObjectToString(d.date));
        if (d.savePrice) {
            savePriceInNote = d.savePrice;
        }

        req.putParam('delivery_value', NKTypeConvertor().toKotlinList(collect((d as ProductNote).products, Number(cid), true, savePriceInNote)));
        req.putParam('ent_id', Number(cid));
        req.putParam('with_price', usePriceInNote);
        req.putParam('connected_id', NKTypeConvertor().toKotlinLong((d as ProductNote).bul));
        req.putParam('notes', (d as ProductNote).comment);
        req.putParam('date_issued', JSDB().getDatesManipulator().dateNow());
        if (d.fromOrder)
            req.putParam('fromOrder', d.fromOrder);
        if (Number(d.id)) {
            req.putParam('delivery_id', Number(d.id));
        }

        const linkedOrderId = linkedOrderIdOf(d);
        if (linkedOrderId)
            req.putParam('order_id', linkedOrderId);

        if ((d as any).staticData)
            req.putParam('static_data', deserializeDetails((d as any).staticData));


    } else if (d.type === 'visit_note') {
        req = new ApiCall('NEW_CLIENT_VISIT_NOTE');
        req.putParam('document_date', dateObjectToString(d.date));
        // if (d.product)
        //     req.putParam('pd', d.product);
        if (d.payment)
            req.putParam('payment', d.payment);


        if (d?.product && d?.product?.amount) {
            const x: any = JSDB().createProductDelivery(d.product.id);
            x.isClient = true;
            x.value = d.product.amount;
            x.returns = 0;
            x.price = d.product.price

            req.putParam('pd', x);
        }


        req.putParam('client_id', Number(cid));
        req.putParam('lon_lat', "");
        req.putParam('comment', d.comment);
        req.putParam('date_issued', JSDB().getDatesManipulator().dateNow());
        req.putParam('states', NKTypeConvertor().toKotlinList(d?.states ?? []));
        if(d?.products)
            req.putParam('delivery_value', NKTypeConvertor().toKotlinList(collect((d as ProductNote).products, Number(cid), true, savePriceInNote)));
        const visitOrderId = linkedOrderIdOf(d);
        if (visitOrderId)
            req.putParam('order_id', visitOrderId);

    } else if (d.type === 'order') {
        req = new ApiCall('NEW_CLIENT_ORDER');
        req.putParam('date', dateObjectToString(d.date));
        if (d.savePrice) {
            savePriceInNote = d.savePrice;
        }
        req.putParam('delivery_value', NKTypeConvertor().toKotlinList(collect((d as ProductNote).products, Number(cid), true, savePriceInNote)));
        req.putParam('sup_delivery_value', NKTypeConvertor().toKotlinList([]));

        req.putParam('ent_id', Number(cid));
        req.putParam('with_price', usePriceInNote);
        req.putParam('connected_id', (d as ProductNote).bul);
        req.putParam('notes', (d as ProductNote).comment);
        req.putParam('date_issued', JSDB().getDatesManipulator().dateNow());
        if (d.fromOrder)
            req.putParam('status', 11)
        if ((d as any).staticData)
            req.putParam('static_data', deserializeDetails((d as any).staticData));
        if ((d as any).delivery_date)
            req.putParam('delivery_date', dateObjectToString((d as any).delivery_date));
    } else if (d.type === 'invoice' || d.type === 'tax_invoice' || d.type === 'refund') {
        req = new ApiCall('NEW_CLIENT_TAX_NOTE');
        const dateIssued = (JSDB().getDatesManipulator().dateNow());
        const details = deserializeDetails((d as TaxNote).details!);
        const ct: any[] = [];
        let dv: any = null;
        if ((d as TaxNote).hand > 0) {

            ct.push(JSDB().createTaxNoteDataFromFreeValue((d as TaxNote).hand_text ?? 'סכום ידני', (d as TaxNote).hand, (d as TaxNote).hand_tax === 0, dateObjectToString(d.date)));
        }

        if ((d as TaxNote).handArray && (d as TaxNote).handArray!.length > 0) {
            (d as TaxNote).handArray!.forEach((k) => {
                if (roundDecimals(k.value * k.amount) != 0) {
                    const include = k.includeTax !== undefined
                        ? !!k.includeTax
                        : JSDB().getClient(Number(cid)).first.getIncludeTax() == 1
                    const tax = k.tax * k.amount
                    const value = k.value * k.amount + (include ? 0 : tax)
                    ct.push(JSDB().createTaxNoteDataFromFreeValue(k.description, roundDecimals(value), roundDecimals(k.tax) == 0, dateObjectToString(d.date), k.amount));
                }
            })

        }

        if ((d as TaxNote).products.length > 0) {
            const pds = NKTypeConvertor().toKotlinList(collect((d as TaxNote).products, Number(cid), true, true));
            const result = JSDB().productDeliveryToAmount(pds, Number(d.entId), dateObjectToString(d.date));

            const productsTax = roundDecimals(result.second, 4);
            const productsValue = roundDecimals(result.third, 4);
            const productS = JSDB().createTaxNoteDataFromProducts(productsValue, (pds));
            productS.taxPaid = Number(productsTax);
            ct.push(productS);
        }

        if ((d as TaxNote).deliveryCertificatesIds.length > 0) {
            const fromNotes = JSDB().createTaxNoteDataFromNotesNew(Number(cid), NKTypeConvertor().toKotlinList((d as TaxNote).deliveryCertificatesIds), false, dateObjectToString(d.date));

            const secondData = fromNotes.third.third;
            ct.push(fromNotes.first);
            if (secondData)
                ct.push(secondData);
            dv = fromNotes.second;

        }
        const payments: any[] = deserializePaymentsForBackend((d as PayNote).payments);
        if (Math.abs((d as TaxNote).round) !== 0) {
            ct.push(JSDB().createTaxNoteDataFromRound(Number((d as TaxNote).round), Number((d as TaxNote).round_tax)));
        }
        let t = 0;
        if (d.type == 'invoice') {
            t = 0;
        } else if (d.type == 'tax_invoice') {
            t = 1;
        } else {
            t = 2;
        }

        req
            .putParam('client_id', Number(cid))
            .putParam('date', dateIssued)
            .putParam('document_date', dateObjectToString(d.date))
            .putParam('value', roundDecimals(d.preValue!, 4))
            .putParam('total_value', roundDecimals(d.mainValue, 4))
            .putParam('details', details)
            .putParam('type', t)
            .putParam('cover_dates', '')
            .putParam('paymentsData', NKTypeConvertor().toKotlinList(payments))
            .putParam('dataValues', NKTypeConvertor().toKotlinList(ct))
            .putParam('discount_percent', NKTypeConvertor().toKotlinFloat((d as TaxNote).discount))
            .putParam('with_price', usePriceInNote)
            .putParam('delivery_notes', dv)
            .putParam('external_details', (d as TaxNote).comment)
            .putParam("notes2", (d as TaxNote).notes2)
            .putParam("notes3", (d as TaxNote).notes3)
            .putParam("notes4", (d as TaxNote).notes4)
            .putParam("notes5", (d as TaxNote).notes5)


        const linkedOrderId = linkedOrderIdOf(d);
        if (linkedOrderId)
            req.putParam('order_id', linkedOrderId);
        if (Number(d.id)) {
            req.putParam('tax_note_id', Number(d.id));
        }
        if(d.fromOrder)
            req.putParam('fromOrder', true);
        if (d.taxConfirmation?.toString().trim())
            req.putParam('taxConfirmation', d.taxConfirmation.toString().trim());

    } else if (d.type === 'sup_tax_invoice' || d.type === 'sup_invoice' || d.type === 'sup_refund') {
        req = new ApiCall('NEW_CLIENT_TAX_NOTE');
        const dateIssued = (JSDB().getDatesManipulator().dateNow());
        const details = applySupplierInputEquipment(
            deserializeDetails((d as TaxNote).details!),
            (d as any).supplierInputEquipment ?? (d as TaxNote).details?.supplierInputEquipment
        );
        const ct: any[] = [];
        let dv: any = null;
        if ((d as TaxNote).hand > 0) {

            ct.push(JSDB().createTaxNoteDataFromFreeValue((d as TaxNote).hand_text ?? 'סכום ידני', (d as TaxNote).hand, (d as TaxNote).hand_tax === 0, dateObjectToString(d.date)));
        }

        if ((d as TaxNote).handArray && (d as TaxNote).handArray!.length > 0) {
            (d as TaxNote).handArray!.forEach((k) => {
                if (roundDecimals(k.value * k.amount) != 0) {
                    const include = k.includeTax !== undefined
                        ? !!k.includeTax
                        : JSDB().getSupplier(Number(cid)).first.getIncludeTax() == 1
                    const tax = k.tax * k.amount
                    const value = k.value * k.amount + (include ? 0 : tax)
                    ct.push(JSDB().createTaxNoteDataFromFreeValue(k.description, roundDecimals(value), roundDecimals(k.tax) == 0, dateObjectToString(d.date), k.amount));
                }
            })

        }

        if ((d as TaxNote).products.length > 0) {
            const pds = NKTypeConvertor().toKotlinList(collect((d as TaxNote).products, Number(cid), false, true));
            const result = JSDB().productDeliveryToAmount(pds, Number(d.entId), dateObjectToString(d.date), false);

            const productsTax = roundDecimals(result.second, 4);
            const productsValue = roundDecimals(result.third, 4);
            const productS = JSDB().createTaxNoteDataFromProducts(productsValue, (pds));
            productS.taxPaid = Number(productsTax);
            ct.push(productS);
        }

        if ((d as TaxNote).deliveryCertificatesIds.length > 0) {
            const fromNotes = JSDB().createTaxNoteDataFromNotesNew(Number(cid), NKTypeConvertor().toKotlinList((d as TaxNote).deliveryCertificatesIds), true, dateObjectToString(d.date));
            const secondData = fromNotes.third.third;
            ct.push(fromNotes.first);
            if (secondData)
                ct.push(secondData);
            dv = fromNotes.second;

        }
        const payments: any[] = deserializePaymentsForBackend((d as PayNote).payments);
        if (Math.abs((d as TaxNote).round) !== 0) {
            ct.push(JSDB().createTaxNoteDataFromRound(Number((d as TaxNote).round), Number((d as TaxNote).round_tax)));
        }
        let t = 0;
        if (d.type == 'sup_invoice') {
            t = 0;
        } else if (d.type == 'sup_tax_invoice') {
            t = 1;
        } else {
            t = 2;
        }

        req
            .putParam('client_id', Number(cid))
            .putParam('date', dateIssued)
            .putParam('document_date', dateObjectToString(d.date))
            .putParam('value', roundDecimals(d.preValue!, 4))
            .putParam('total_value', roundDecimals(d.mainValue, 4))
            .putParam('details', details)
            .putParam('type', t)
            .putParam('cover_dates', '')
            .putParam('paymentsData', NKTypeConvertor().toKotlinList(payments))
            .putParam('dataValues', NKTypeConvertor().toKotlinList(ct))
            .putParam('discount_percent', NKTypeConvertor().toKotlinFloat((d as TaxNote).discount))
            // Deployed JS still NPE's in newClientTaxNote with_price for suppliers
            // (always called getClient). Skip price-list sync until the Kotlin fix
            // is deployed via deployWebBundle; invoice create still works.
            .putParam('with_price', false)
            .putParam('delivery_notes', dv)
            .putParam('external_details', (d as TaxNote).comment)
            .putParam('sup', true);

        const invoiceNumber = (d as TaxNote).supplierInvoiceNumber?.trim();
        if (invoiceNumber)
            req.putParam('supplier_invoice_number', invoiceNumber);

        if (d.refId)
            req.putParam('order_id', Number(d.refId));
        // Supplier invoices get their NiHulKav id from the ERP sequence.
        // The printed supplier invoice number is supplier_invoice_number only.

        if (d.taxConfirmation?.toString().trim())
            req.putParam('taxConfirmation', d.taxConfirmation.toString().trim());

    } else if (d.type === 'receipt' || d.type === 'sup_receipt') {
        req = new ApiCall('NEW_CLIENT_PAY');
        const dateIssued = (JSDB().getDatesManipulator().dateNow());
        const details = deserializeDetails((d as TaxNote).details!);
        const payments: any[] = deserializePaymentsForBackend((d as PayNote).payments);
        const tax_ids: string = (d as PayNote).receiptsIds.sort((s) => -s).join(',');


        const refundRest = (d as PayNote).refundRest;

        req
            .putParam('client_id', Number(cid))
            .putParam('date', dateIssued)

            .putParam('document_date', dateObjectToString(d.date))
            .putParam('value', roundDecimals(d.mainValue!, 4))
            .putParam('details', details)
            .putParam('paymentsData', NKTypeConvertor().toKotlinList(payments))
            .putParam('tax_note_id', (tax_ids))
            .putParam('external_details', (d as TaxNote).comment)
        if(d.ref_id)
            req.putParam('ref_id', d.ref_id);

        if (refundRest)
            req.putParam('refundRest', refundRest);
        if (d.type === 'sup_receipt')
            req.putParam('sup', true);

    } else {
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    }
    if (d.notes2) {
        req.putParam('notes2', d.notes2);
    }
    if (d.notes3) {
        req.putParam('notes3', d.notes3);
    }
    if (d.notes4) {
        req.putParam('notes4', d.notes4);
    }
    if (d.notes5) {
        req.putParam('notes5', d.notes5);
    }
    if (d.increase_id) {
        req.putParam('increase_id', d.increase_id)

    } else if (JSDB().curUser?.increase_id) {
        req.putParam('increase_id', JSDB().curUser.increase_id)
    }
    if (d.agent) {
        req.putParam('agent', d.agent);
    } else {
        req.putParam('agent', JSDB().currentAgent);
    }

    console.log(req)
    const result = await req.execute(undefined,undefined,20000);

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });

    if (d.type === 'delivery_certificate' || d.type === 'tax_invoice' || d.type === 'invoice' || d.type === 'refund' || d.type === 'sup_invoice' || d.type === 'sup_tax_invoice' || d.type === 'sup_refund') {
        return docResultsDeserialize(result.first); //for njow
    } else {
        return deserializeDocument(result.first)!;
    }


};

/** Product, manual, and linked-note lines for an existing supplier tax document. */
function buildSupplierTaxLines(d: ExtendedDocument): any[] {
    const cid = Number(d.entId);
    const taxNote = d as TaxNote;
    const ct: any[] = [];
    const date = dateObjectToString(d.date);
    if (taxNote.hand > 0) {
        ct.push(JSDB().createTaxNoteDataFromFreeValue(taxNote.hand_text ?? 'סכום ידני', taxNote.hand, taxNote.hand_tax === 0, date));
    }
    if (taxNote.handArray && taxNote.handArray.length > 0) {
        const includeDefault = JSDB().getSupplier(cid).first.getIncludeTax() == 1;
        taxNote.handArray.forEach((k) => {
            if (roundDecimals(k.value * k.amount) != 0) {
                const include = k.includeTax !== undefined ? !!k.includeTax : includeDefault;
                const tax = k.tax * k.amount;
                const value = k.value * k.amount + (include ? 0 : tax);
                ct.push(JSDB().createTaxNoteDataFromFreeValue(k.description, roundDecimals(value), roundDecimals(k.tax) == 0, date, k.amount));
            }
        });
    }
    const priced = (taxNote.products ?? []).filter((p) => p.quantity > 0 || p.quantityReturns > 0 || ((p.quantitySecond ?? 0) > 0 && (p.conversion_ratio ?? 0) > 0));
    if (priced.length > 0) {
        const pds = NKTypeConvertor().toKotlinList(collect(priced, cid, false, true));
        const result = JSDB().productDeliveryToAmount(pds, cid, date, false);
        const productS = JSDB().createTaxNoteDataFromProducts(roundDecimals(result.third, 4), pds);
        productS.taxPaid = Number(roundDecimals(result.second, 4));
        ct.push(productS);
    }
    if (taxNote.deliveryCertificatesIds && taxNote.deliveryCertificatesIds.length > 0) {
        const fromNotes = JSDB().createTaxNoteDataFromNotesNew(cid, NKTypeConvertor().toKotlinList(taxNote.deliveryCertificatesIds), true, date);
        ct.push(fromNotes.first);
        if (fromNotes.third?.third)
            ct.push(fromNotes.third.third);
    }
    return ct;
}

export const updateRealCustomerDocument: (d: ExtendedDocument) => Promise<ExtendedDocument> = async (d) => {
    let req: ApiCall;

    const savePriceInNote = d?.savePriceInSpecificNote ?? JSDB().getUser().first.savePriceInNote()
    const savePriceGeneral = d?.savePriceInGeneral ?? JSDB().getUser().first.needPriceInNoteShow()
    const preserveExistingUsePrice = d?.preserveExistingUsePrice === true
    if (d.type === 'delivery_certificate') {
        req = new ApiCall('UPDATE_CLIENT_NOTE');
        // if ((d as ProductNote).bul)
        //     req.putParam('connected_id', (d as ProductNote).bul);
        req.putParam('notes', (d as ProductNote).comment);
        req.putParam('notes2', (d as ProductNote).notes2);
        req.putParam('notes3', (d as ProductNote).notes3);
        req.putParam('notes4', (d as ProductNote).notes4);
        req.putParam('notes5', (d as ProductNote).notes5);
        req.putParam('id', Number(d.id));

        if (!isNaN(Number((d as ProductNote).bul))) {
            req.putParam('connected_id', NKTypeConvertor().toKotlinLong(Number((d as ProductNote).bul)));
        }
        req.putParam('delivery_value', NKTypeConvertor().toKotlinList(collect((d as ProductNote).products, Number(d.entId), true, savePriceInNote || JSDB().getUser().first.note_price == 1, preserveExistingUsePrice)));
        if (JSDB().getCompany() == "carmelberry") // remove
            req.putParam('updatePrice', false);
        else
            req.putParam('updatePrice', savePriceGeneral);
        if (JSDB().getCompany() == "galrazit") // remove
            req.putParam("agentEdit", JSDB().currentAgent)
        if (d.date_edit)
            req.putParam("date", dateObjectToString(d.date));
        if ((d as any).entId_edit)
            req.putParam("ent_id", Number(d.entId));
        if ((d as any).staticData_edit && (d as any).staticData)
            req.putParam('static_data', deserializeDetails((d as any).staticData));

    } else if (d.type === 'order') {
        req = new ApiCall('UPDATE_CLIENT_ORDER');
        // req.putParam('date', dateObjectToString(d.date));
        req.putParam('order_id', Number(d.id));
        // if((d as ProductNote).bul)
        // req.putParam('connected_id', (d as ProductNote).bul);
        req.putParam('notes', (d as ProductNote).comment);
        req.putParam('notes2', (d as ProductNote).notes2);
        req.putParam('notes3', (d as ProductNote).notes3);
        req.putParam('notes4', (d as ProductNote).notes4);
        req.putParam('notes5', (d as ProductNote).notes5);
        req.putParam('delivery_value', NKTypeConvertor().toKotlinList(collect((d as ProductNote).products, Number(d.entId), true, savePriceInNote || JSDB().getUser().first.note_price == 1, preserveExistingUsePrice)));

        req.putParam('updatePrice', savePriceGeneral);
        if(d.entId=="-1"){
            req.putParam('inventory', "1");
        }
        if (d.date_edit)
            req.putParam("date", dateObjectToString(d.date));
        if ((d as any).staticData_edit && (d as any).staticData)
            req.putParam('static_data', deserializeDetails((d as any).staticData));
        if ((d as any).delivery_date_edit)
            req.putParam('delivery_date', (d as any).delivery_date ? dateObjectToString((d as any).delivery_date) : '');

    } else if (d.type === 'visit_note') {
        req = new ApiCall('UPDATE_CLIENT_VISIT_NOTE');
        // req.putParam('date', dateObjectToString(d.date));
        req.putParam('id', Number(d.id));
        // if((d as ProductNote).bul)
        // req.putParam('connected_id', (d as ProductNote).bul);
        req.putParam('comment', (d).comment);
        req.putParam('date', dateObjectToString((d).date));
        if(d.products){
            req.putParam('delivery_value', NKTypeConvertor().toKotlinList(collect((d as ProductNote).products, Number(d.entId), true, savePriceInNote || JSDB().getUser().first.note_price == 1, preserveExistingUsePrice)));
        }

        if (d.payment != undefined)
            req.putParam('payment', d.payment);
        req.putParam('states', NKTypeConvertor().toKotlinList(d.states.map((s) => visitStatesMap[s] ?? s)));
        if (d?.product?.amount != undefined) {
            const x: any = JSDB().createProductDelivery(d.product.id);
            x.isClient = true;
            x.value = d.product.amount;
            x.returns = 0;
            x.price = d.product.price

            req.putParam('pd', x);
            const visitOrderId = linkedOrderIdOf(d);
            if (visitOrderId)
                req.putParam('order_id', visitOrderId)
        }


    } else if (d.type == 'supplier_note') {
        req = new ApiCall('UPDATE_SUPPLIER_NOTE');
        req.putParam('notes', (d as ProductNote).comment);
        req.putParam('notes2', (d as ProductNote).notes2);
        req.putParam('notes3', (d as ProductNote).notes3);
        req.putParam('notes4', (d as ProductNote).notes4);
        if (!isNaN(Number((d as ProductNote).bul))) {
            req.putParam('connected_id', NKTypeConvertor().toKotlinLong(Number((d as ProductNote).bul)));
        }
        req.putParam('notes5', (d as ProductNote).notes5);
        req.putParam('id', Number(d.id));
        req.putParam('delivery_value', NKTypeConvertor().toKotlinList(collect((d as ProductNote).products, Number(d.entId), false, JSDB().getUser().first.note_price == 1)));
        if (d.date_edit)
            req.putParam("date", dateObjectToString(d.date));

    } else if (d.type === 'invoice' || d.type === 'tax_invoice' || d.type === 'refund'
        || d.type === 'sup_invoice' || d.type === 'sup_tax_invoice' || d.type === 'sup_refund') {
        req = new ApiCall('UPDATE_ALL_CLIENT_TAX_NOTE');

        let t = 0;
        if (d.type === 'invoice' || d.type === 'sup_invoice') {
            t = 0;
        } else if (d.type === 'tax_invoice' || d.type === 'sup_tax_invoice') {
            t = 1;
        } else {
            t = 2;
        }
        req
            .putParam('types', NKTypeConvertor().toKotlinList([t]))
            .putParam('ids', NKTypeConvertor().toKotlinList([Number(d.id)]))

            .putParam('external_details', NKTypeConvertor().toKotlinList([(d as TaxNote).comment]))
        if ((d.type === 'tax_invoice' || d.type === 'sup_tax_invoice') && (d as PayNote).payments) {
            const payments = [NKTypeConvertor().toKotlinList(deserializePaymentsForBackend((d as PayNote).payments))]
            req.putParam('paymentsData', NKTypeConvertor().toKotlinList(payments))
        }

        const supplierTax = d.type === 'sup_invoice' || d.type === 'sup_tax_invoice' || d.type === 'sup_refund';
        const putNote = (key: 'notes2' | 'notes3' | 'notes4' | 'notes5') => {
            const value = (d as ProductNote)[key];
            if (supplierTax ? value != null : !!value)
                req.putParam(key, NKTypeConvertor().toKotlinList([value ?? '']));
        };
        putNote('notes2');
        putNote('notes3');
        putNote('notes4');
        putNote('notes5');
        if (d.taxConfirmation != undefined)
            req.putParam('taxConfirmation', NKTypeConvertor().toKotlinList([d.taxConfirmation.toString()]))
        if (supplierTax) {
            const taxNote = d as TaxNote;
            req.putParam('sup', true);
            req.putParam('supplier_invoice_number', NKTypeConvertor().toKotlinList([
                (taxNote.supplierInvoiceNumber ?? '').toString()
            ]));
            req.putParam('values', NKTypeConvertor().toKotlinList([roundDecimals(Number(taxNote.preValue ?? 0), 4)]));
            req.putParam('total_values', NKTypeConvertor().toKotlinList([roundDecimals(Number(taxNote.mainValue ?? 0), 4)]));
            req.putParam('discount_percents', NKTypeConvertor().toKotlinList([Number(taxNote.discount ?? 0)]));
            if (d.type !== 'sup_tax_invoice' && taxNote.value_left != null)
                req.putParam('value_left', NKTypeConvertor().toKotlinList([Number(taxNote.value_left)]));
            if ((d as any).date_edit)
                req.putParam('document_dates', NKTypeConvertor().toKotlinList([dateObjectToString(d.date)]));
            if ((d as any).lines_edit) {
                const lines = [NKTypeConvertor().toKotlinList(buildSupplierTaxLines(d))];
                req.putParam('dataValues', NKTypeConvertor().toKotlinList(lines));
            }
            if ((d as any).entId_edit && Number(d.entId) > 0)
                req.putParam('client_ids', NKTypeConvertor().toKotlinList([Number(d.entId)]));
            if ((d as any).details_edit && taxNote.details) {
                const details = applySupplierInputEquipment(
                    deserializeDetails(taxNote.details),
                    (d as any).supplierInputEquipment ?? taxNote.details.supplierInputEquipment
                );
                req.putParam('details', NKTypeConvertor().toKotlinList([details]));
            }
        }
    } else if (d.type === 'receipt') {
        req = new ApiCall('UPDATE_CLIENT_PAY')
            .putParam('id', Number(d.id))
            .putParam('external_details', (d as TaxNote).comment)

    } else {
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    }
    console.log(req)
    let result: any;
    try {
        result = await req.execute();
    } catch (e: any) {
        // ApiCall rejects with the Kotlin status enum; surface the optimistic-lock case by name so
        // DocumentPreview can open the conflict dialog instead of a generic error.
        const nm = e?.name || e?.message || req.lastError?.() || '';
        if (String(nm).includes('VERSION_CONFLICT')) {
            throw Object.assign(new Error('VERSION_CONFLICT'), {name: 'VERSION_CONFLICT'});
        }
        throw e;
    }

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            if (result?.second?.name === 'ERROR_DUPLICATE')
                reject(new Error('Duplicate'));
            else if (result?.second?.name === 'VERSION_CONFLICT')
                reject(Object.assign(new Error('VERSION_CONFLICT'), {name: 'VERSION_CONFLICT'}));
            else
                reject(Error);
        });
    if (d.type === 'tax_invoice' || d.type === 'invoice' || d.type === 'refund'
        || d.type === 'sup_invoice' || d.type === 'sup_tax_invoice' || d.type === 'sup_refund') {

        const docs = docResultsDeserialize(result.first)
        return docs.find((dd) => dd.id == Number(d.id) && d.type == dd.type) ?? docs[0];
    } else {
        return deserializeDocument(result.first)!;
    }


};

export const getDocumentPdf: (d: ExtendedDocument, origin: boolean) => Promise<any> = async (d, origin) => {
    const req: ApiCall = new ApiCall('GET_DOCUMENT_PDF');
    req.putParam('doc', d.nkObject);
    req.putParam('origin', origin);
    if (isSupplierDocument(d.type)) {
        req.putParam('sup', true);
    }
    if (JSDB().getCurrentAgent()?.print == 3 ||  JSDB().getCurrentAgent()?.print == 19)
        req.putParam('force_price', false);

    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    // bytearray
    return result.first;

};

export const MAX_DOC_PHOTOS = 3;

export function documentPhotoCount(d?: ExtendedDocument | null): number {
    if (!d) return 0;
    const raw = d.photoCount
        ?? d.header?.photoCount
        ?? (typeof d.nkObject?.photoCount === 'function' ? d.nkObject.photoCount() : undefined);
    const n = Number(raw);
    if (Number.isFinite(n) && n > 0) return Math.min(MAX_DOC_PHOTOS, n);
    return d.photo ? 1 : 0;
}

function kotlinListToArray(list: any): any[] {
    if (!list) return [];
    if (Array.isArray(list)) return list;
    const n = typeof list.size === 'number' ? list.size
        : (typeof list.size === 'function' ? list.size() : (list.length || 0));
    const out: any[] = [];
    for (let i = 0; i < n; i += 1) {
        const item = typeof list.get === 'function' ? list.get(i) : list[i];
        if (item != null) out.push(item);
    }
    return out;
}

/**
 * photo_get_img answers 200 with an error JSON body when the S3 object is
 * missing, so a slot is only a real photo if it carries JPEG/PNG magic bytes.
 */
export function looksLikeImage(bytes: any): boolean {
    if (bytes == null || typeof bytes.length !== 'number' || bytes.length < 4) return false;
    const a = bytes[0] & 0xFF;
    const b = bytes[1] & 0xFF;
    return (a === 0xFF && b === 0xD8) || (a === 0x89 && b === 0x50);
}

export function getLastLoadedFieldPhotos(): any[] {
    try {
        return kotlinListToArray(JSDB().fieldPhotos).filter(looksLikeImage);
    } catch {
        return [];
    }
}

export const getDocumentSign: (d: ExtendedDocument) => Promise<any> = async (d) => {
    const req: ApiCall = new ApiCall('GET_SIGN_IMG');
    req.putParam('doc_type', documentTypes[d.type].nkType);
    req.putParam('note_id', d.id);
    const result = await req.execute();
    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    // bytearray
    return result.first.first;

};
export const getDocumentPhotos: (d: ExtendedDocument) => Promise<any[]> = async (d) => {
    const req: ApiCall = new ApiCall('GET_SIGN_PHOTO');
    req.putParam('note_id', d.id);
    req.putParam('doc_type', documentTypes[d.type].nkType);
    try {
        const result = await req.execute();
        if (result == null || result.second.name !== 'SUCCESS') return [];
        const first = result.first?.first;
        const loaded = getLastLoadedFieldPhotos();
        if (loaded.length > 0) return loaded.slice(0, MAX_DOC_PHOTOS);
        return first ? [first] : [];
    } catch {
        return [];
    }
};
export const getDocumentPhoto: (d: ExtendedDocument, index?: number) => Promise<any> = async (d, index) => {
    const req: ApiCall = new ApiCall('GET_SIGN_PHOTO');
    req.putParam('note_id', d.id);
    req.putParam('doc_type', documentTypes[d.type].nkType);
    try {
        const result = await req.execute();
        if (result == null || result.second.name !== 'SUCCESS') return null;
        if (index != null && index > 0) {
            const loaded = getLastLoadedFieldPhotos();
            if (loaded[index]) return loaded[index];
        }
        return result.first?.first ?? null;
    } catch {
        return null;
    }
};
export const uploadDocumentPhoto: (d: ExtendedDocument, byteArr, index?: number) => Promise<any> = async (d, byteArr, index) => {
    const req: ApiCall = new ApiCall('UPLOAD_SIGN_PHOTO');
    req.putParam('note_id', d.id);
    req.putParam('doc_type', documentTypes[d.type].nkType);
    req.putParam('image', byteArr);
    req.putParam('date', dateTimeObjectToString(new Date()));
    if (index != null) req.putParam('index', index);
    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    // bytearray
    return result.first;

};
export const deleteDocumentPhoto: (d: ExtendedDocument, index: number) => Promise<any> = async (d, index) => {
    const req: ApiCall = new ApiCall('DELETE_SIGN_PHOTO');
    req.putParam('note_id', d.id);
    req.putParam('doc_type', documentTypes[d.type].nkType);
    req.putParam('index', index);
    req.putParam('date', dateTimeObjectToString(new Date()));
    const result = await req.execute();
    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    return result.first;
};
export const getCartesetPDF: (fromDate: Date, toDate: Date, cid?: number, open?: boolean, sup?: boolean) => Promise<any> = async (fromDate, toDate, cid, open, sup) => {
    const req: ApiCall = new ApiCall('GET_CLIENT_CARTESET_PDF');
    if (cid)
        req.putParam('id', Number(cid));
    if (open)
        req.putParam('open', open);
    if (sup)
        req.putParam('sup', true);
    req.putParam('dates', `${dateObjectToString(fromDate)}..${dateObjectToString(toDate)}`.toString());
    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    // bytearray
    return result.first;

};
export const getOrderDocumentPdf: (d?: ExtendedDocument[], dint?: number[]) => Promise<any> = async (d, dint) => {
    const req: ApiCall = new ApiCall('CALCULATE_CLIENT_ORDER_PDF');
    if (d)
        req.putParam('ids', NKTypeConvertor().toKotlinList(d.map((p) => p.id)));
    if (dint)
        req.putParam('ids', NKTypeConvertor().toKotlinList(dint));
    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    // bytearray
    return result.first;

};
export const getCofcLink: (id: number, date: Date) => Promise<any> = async (id, date) => {
    const req: ApiCall = new ApiCall('REGISTER_COFC');
    req.putParam('id', id);
    req.putParam('date', '');
    req.putParam('open_date', dateObjectToString(date));
    req.putParam('short', true);

    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    // string
    return result.first;

};

export const getCofcReturnLink: (id: number, date: Date) => Promise<any> = async (id, date) => {
    const req: ApiCall = new ApiCall('REGISTER_COFC');
    req.putParam('id', id);
    req.putParam('date', '');
    req.putParam('open_date', dateObjectToString(date));
    req.putParam('short', true);
    req.putParam('returns', true);

    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    // string
    return result.first;

};

export const updateGeo: (ids: number[], force?: boolean) => Promise<number[]> = async (ids, force) => {
    let req: ApiCall = new ApiCall('UPDATE_GEO_NAME');
    req.putParam('ids', NKTypeConvertor().toKotlinList(ids));
    if (force)
        req.putParam('force', force);


    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    // string

    const res: number[] = []
    if (result.first.size > 0)
        result.first.toArray().forEach((c) => {
            res.push(ids[c]);

        })
    return res

};
export const optimizeRouteClients: (ids: number[], date?: Date, geoTransfrom?: boolean, initLoc?: string, endLoc?: string) => Promise<number[]> = async (ids, date, geoTransfrom, initLoc, endLoc) => {
    if (date) {
        const req: ApiCall = new ApiCall('OPTIMIZE_ROUTE_DRIVERS');
        req.putParam('date', dateObjectToString(date));
        req.putParam('save', true);
        req.putParam('ids', NKTypeConvertor().toKotlinList(ids));
        if (geoTransfrom)
            req.putParam('geoTransfrom', geoTransfrom);
        if (initLoc)
            req.putParam('start_point', initLoc);
        if (endLoc)
            req.putParam('end_point', endLoc);

        const result = await req.execute();

        if (result == null || result.second.name !== 'SUCCESS')
            return new Promise((resolve, reject) => {
                reject(Error);
            });

        const res: number[] = []
        result.first.toArray().forEach((c) => {
            res.push(ids[c]);
        })
        return res
    }

    if (geoTransfrom) {
        await updateGeo(ids, false);
    }

    return (await optimizeClientIds(ids, {
        startPoint: initLoc,
        endPoint: endLoc,
    })).orderedClientIds;
};

/**
 * Like optimizeRouteClients, but for optimizing a specific set of *rows* rather than plain client ids —
 * the same client can appear more than once here (its normal order plus a one-off order carrying a
 * forced/כתובת מאולצת address), so the result exposes the original row indices (not just ids) to let
 * callers map the optimized order back to the exact row, instead of colliding on a shared client id.
 */
export const optimizeRouteClientRows: (
    ids: number[],
    geoTransfrom?: boolean,
    initLoc?: string,
    endLoc?: string,
    forcedAddresses?: (string | undefined)[]
) => Promise<OptimizedClientRows> = async (ids, geoTransfrom, initLoc, endLoc, forcedAddresses) => {
    if (geoTransfrom) {
        await updateGeo(ids, false);
    }

    return optimizeClientIds(ids, {
        startPoint: initLoc,
        endPoint: endLoc,
        forcedAddresses,
    });
};
export const optimizeDriversToCollectors: (ids: number[], drivers: number[], collectors: number[], date: Date, maxBoxSize: number, inverseToCollectors: boolean) => Promise<number[]> = async (ids, drivers, collectors, date, maxBoxSize, inverseToCollectors) => {
    let req: ApiCall = new ApiCall('OPTIMIZE_COLLECTORS_SPLIT');
    req.putParam('date', dateObjectToString(date));
    req.putParam('save', true);
    req.putParam('ids', NKTypeConvertor().toKotlinList(ids));
    req.putParam('driver_id', NKTypeConvertor().toKotlinList(drivers));
    req.putParam('collector_id', NKTypeConvertor().toKotlinList(collectors));
    req.putParam('maxBoxSize', maxBoxSize);
    req.putParam('inverseToCollectors', inverseToCollectors);


    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    // string

    const res: number[] = []
    result.first.toArray().forEach((c) => {
        res.push(ids[c]);

    })
    return res

};
export const getNameOfDoc: (d?: ExtendedDocument[]) => string = (d) => {
    if (!d || d.length == 0) {
        return "מסמכים"
    } else {
        const name = new Set(d.map((i) => i.entName))
        const t = new Set(d.map((i) => i.type))
        let nameDoc = ""
        let tDoc = ""
        if (t.size == 1) {
            const k = t.keys().next().value
            tDoc = documentTypes[k].name + "_" + (d.length == 1 ? displayDocumentId(d[0]) : "לקוחות")
        } else {
            tDoc = "מסמכים"
        }
        if (name.size == 1) {
            nameDoc = name.keys().next().value
        }
        return nameDoc + "_" + tDoc


    }
}
export const getMassPdfDocRef = (doc: ExtendedDocument): { id: number; docType: number } => {
    const headerType = doc?.header?.docType;
    const orderId = doc?.orderId ?? doc?.header?.order_id ?? doc?.nkObject?.order_id;
    const isVisit = doc?.type === 'visit_note' || headerType === documentTypes.visit_note.nkType;
    // Visit notes have no PDF of their own — print/send the connected order, same as calcPdf.
    if (isVisit && orderId != undefined && Number(orderId) > 0) {
        return { id: Number(orderId), docType: documentTypes.order.nkType };
    }
    // Supplier tax notes must go to the jar as 16/17/18, not 0/1/2.
    const typeNk = documentTypes[doc?.type]?.nkType;
    if (isSupplierDocument(doc.type) && typeNk != null) {
        return { id: Number(doc.id), docType: typeNk };
    }
    const connectedType = typeof doc?.nkObject?.getConnectedDocType === 'function'
        ? doc.nkObject.getConnectedDocType()
        : headerType;
    return { id: Number(doc.id), docType: connectedType };
};

/** ids/types for WhatsApp/email document send — visit notes go out as their order, like printing. */
export const massSendFilesOf = (docs: ExtendedDocument[]) => {
    const refs = docs.map(getMassPdfDocRef);
    return {
        ids: refs.map((r) => r.id),
        types: refs.map((r) => r.docType),
    };
};
export const getMassDocumentPdf: (d?: ExtendedDocument[], dint?: number[], types?: number[], origin?: boolean, originForce?: number, dates?: string, price_value?: number, only_debt?: boolean, collection?: boolean, zip?: boolean, photos?: boolean) => Promise<any> = async (d, dint, types, origin, originForce, dates, price_value, only_debt, collection, zip, photos) => {
    const req: ApiCall = new ApiCall('CALCULATE_CLIENT_MASS_DOC_PDF');
    if (d) {
        req.putParam('ids', NKTypeConvertor().toKotlinList(d.map((p) => getMassPdfDocRef(p).id)));
        req.putParam('docs', NKTypeConvertor().toKotlinList(d.map((p) => getMassPdfDocRef(p).docType)));
    }

    if (dint)
        req.putParam('ids', NKTypeConvertor().toKotlinList(dint));
    if (types)
        req.putParam('docs', NKTypeConvertor().toKotlinList(types));
    if (origin)
        req.putParam('origin', true);
    if (originForce)
        req.putParam('originForce', originForce);
    if (dates)
        req.putParam('dates', dates);
    if (price_value)
        req.putParam('price_value', price_value);
    if (only_debt)
        req.putParam('only_debt', 1);
    if (collection)
        req.putParam('collection', 1);
    if (zip)
        req.putParam('zip', 1);
    if (photos)
        req.putParam('photos', 1);
    const supplierPdf =
        d?.some((p) => isSupplierDocument(p.type)) ||
        types?.some((t) => t === 6 || (t >= 16 && t <= 22));
    if (supplierPdf) {
        req.putParam('sup', true);
    }

    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });

    // bytearray
    return result.first;

};

export const sendPdfEmail: (byteArr: any, email: string, title: string, doc_id?: number, doc_type?: number) => Promise<boolean> = async (byteArr, email, title, doc_id, doc_type) => {
    const req: ApiCall = new ApiCall('SEND_EMAIL');

    req.putParam('f', byteArr);
    req.putParam('title', title);
    req.putParam('email', email);

    if (doc_id)
        req.putParam('doc_id', doc_id);
    if (doc_type!=undefined)
        req.putParam('doc_type', doc_type);
    const result = await req.execute();

    if (result == null || result.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });

    // bytearray
    return true;

};

export const sendReqForApi: (doc_id: number, doc_type: number, api_method?: number) => Promise<boolean> = async (doc_id, doc_type, api_method) => {
    const req: ApiCall = new ApiCall('SEND_API_REQ');
    req.putParam('doc_id', doc_id);
    req.putParam('doc_type', doc_type);
    if (api_method)
        req.putParam('api_method', api_method);
    const result = await req.execute();
    if (result == null || result.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });

    // bytearray
    return true;

};
export const sendApiAll: (doc_id: number[], doc_type: number[]) => Promise<number[]> = async (doc_id, doc_type) => {
    const req: ApiCall = new ApiCall('SEND_API_REQ');
    req.putParam('doc_id', NKTypeConvertor().toKotlinList(doc_id));
    req.putParam('doc_type', NKTypeConvertor().toKotlinList(doc_type));

    const result = await req.execute();
    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });

    // bytearray
    if (result.first.size > 0)
        return result.first.toArray()

    return [];

};
export const buildNotesSum: (d?: ExtendedDocument[], dint?: number[], tax_note_id?: number[], order?: boolean, force_sum_type?: number,withPricesSummary?:number) => Promise<any> = async (d, dint, tax_note_id, order, force_sum_type,withPricesSummary) => {
    const req: ApiCall = new ApiCall('CALCULATE_client_delivery_easy');
    if (d) {
        req.putParam('ids', NKTypeConvertor().toKotlinList(d.map((p) => p.id)));
    }
    if (dint)
        req.putParam('ids', NKTypeConvertor().toKotlinList(dint));
    if (tax_note_id) {
        req.putParam('tax_id_merge', NKTypeConvertor().toKotlinList(tax_note_id));
    }
    if (order) {
        req.putParam('order', true);
    }
    if (force_sum_type != undefined)
        req.putParam('force_sum_type', force_sum_type);

    if(withPricesSummary != undefined)
        req.putParam('withPrices', withPricesSummary);

    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    // bytearray
    return result.first;

};

export const buildNotesSumByDates: (id, fromDate: Date, toDate: Date, sup?: boolean, ids?: any) => Promise<any> = async (id, fromDate, toDate, sup, ids) => {
    let req: ApiCall = new ApiCall('CALCULATE_client_delivery');
    if (sup) {
        req = new ApiCall('CALCULATE_supplier_delivery');
    }
    if (ids) {
        req.putParam('client_id', id);
        req.putParam('client_ids', NKTypeConvertor().toKotlinList(ids));
    } else {
        req.putParam('client_id', id);
    }

    req.putParam('date_range', `${dateObjectToString(fromDate)}..${dateObjectToString(toDate)}`);


    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    // bytearray
    return result.first;

};

/** Native monthly-account PDF for many clients (calculations.jar method 29). */
export const buildMonthlyAccountAllPdf: (
    fromDate: Date,
    toDate: Date,
    clientIds?: number[],
    opts?: { mergeDates?: boolean; withBarcode?: boolean; productsPerPage?: number },
) => Promise<any> = async (fromDate, toDate, clientIds, opts) => {
    const req: ApiCall = new ApiCall('CALCULATE_MONTHLY_ACCOUNT_ALL_PDF');
    req.putParam('date_range', `${dateObjectToString(fromDate)}..${dateObjectToString(toDate)}`);
    if (clientIds && clientIds.length > 0) {
        req.putParam('ids', NKTypeConvertor().toKotlinList(clientIds));
    }
    if (opts?.mergeDates) {
        req.putParam('merge_dates', 1);
    }
    if (opts?.withBarcode) {
        req.putParam('with_barcode', 1);
    }
    if (opts?.productsPerPage != undefined) {
        req.putParam('products_per_page', opts.productsPerPage);
    }

    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    return result.first;
};

export const buildSupNotesSum: (d?: ExtendedDocument[], dint?: number[], ent_id?: number, dates?: string,withPrices?:number) => Promise<any> = async (d, dint, ent_id, dates,withPrices) => {
    const req: ApiCall = new ApiCall('CALCULATE_supplier_delivery');
    if (d) {
        req.putParam('ids', NKTypeConvertor().toKotlinList(d.map((p) => p.id)));
    }
    if (dint)
        req.putParam('ids', NKTypeConvertor().toKotlinList(dint));
    if (ent_id && dates) {
        req.putParam('client_id', ent_id);
        req.putParam('date_range', dates);
    }
    if(withPrices != undefined)
        req.putParam('withPrices', withPrices);

    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    // bytearray

    return result.first;

};

export const buildQuerySum: (
    ids: number[],
    from: Date,
    to: Date,
    title,
    withNote?: boolean,
    withOrders?: boolean,
    specific_ids?: number[],
    seperate?: number,
    byIds?: number,
    closedF?: boolean,
    inventory?: boolean,
    inventory_down?: boolean,
    /** 0–4: maps to Kotlin `orders_vs_notes_layout` (orders vs delivery PDF layouts). */
    ordersVsNotesLayout?: number,
    /** When true, only rows where order vs delivery quantity differs. */
    onlyQtyMismatch?: boolean
) => Promise<any> = async (
    ids,
    from,
    to,
    title,
    withNote,
    withOrders,
    specific_ids,
    seperate,
    byIds,
    closedF,
    inventory,
    inventory_down,
    ordersVsNotesLayout,
    onlyQtyMismatch
) => {
    const req: ApiCall = new ApiCall('QUERY_SUM_PDF');

    req.putParam('ids', NKTypeConvertor().toKotlinList(ids));
    req.putParam('fromDate', dateObjectToString(from));
    req.putParam('toDate', dateObjectToString(to));
    req.putParam('title', (title));
    req.putParam('issuer', JSDB().currentAgent);
    if (withOrders)
        req.putParam('withOrders', true);
    if (withNote)
        req.putParam('withNotes', true);
    if (specific_ids)
        req.putParam('specific_products', NKTypeConvertor().toKotlinList(specific_ids));
    if (seperate)
        req.putParam('seperate', seperate);
    if (byIds)
        req.putParam('byIds', byIds);
    if(closedF)
        req.putParam('closed', closedF);
    if(inventory)
        req.putParam('inventory', 1);
    if(inventory_down)
        req.putParam('inventory', 2);
    if (ordersVsNotesLayout !== undefined && ordersVsNotesLayout !== null)
        req.putParam('orders_vs_notes_layout', ordersVsNotesLayout);
    if (onlyQtyMismatch)
        req.putParam('only_qty_mismatch', 1);
    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    // bytearray
    return result.first;

};
export const dailyBuildQuerySum: (ids: number[], date: Date, groupType: number, withNote?: number, withOrders?: number, specific_ids?: number[], title?: string, seperate?: number, byIds?: number,closedF?:boolean,inventory?:boolean,inventory_down?:boolean) => Promise<any> = async (ids, date, groupType, withNote, withOrders, specific_ids, title, seperate, byIds,closedF,inventory,inventory_down) => {
    const req: ApiCall = new ApiCall('DRIVER_QUERY_SUM_PDF');

    req.putParam('ids', NKTypeConvertor().toKotlinList(ids));
    req.putParam('date', dateObjectToString(date));
    req.putParam('groupType', (groupType));
    if (specific_ids)
        req.putParam('specific_products', NKTypeConvertor().toKotlinList(specific_ids));
    if (withOrders)
        req.putParam('withOrders', withOrders);
    if (withNote)
        req.putParam('withNotes', withNote);
    if (title)
        req.putParam('title', title);
    if (seperate)
        req.putParam('seperate', seperate);
    if (byIds)
        req.putParam('byIds', byIds);
    if(closedF)
        req.putParam('closed', closedF);
    if(inventory)
        req.putParam('inventory', 1);
    if(inventory_down)
        req.putParam('inventory', 2);

    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    // bytearray
    return result.first;

};


export const update_note_amounts: (d: ExtendedDocument) => Promise<ExtendedDocument | null> = async (d) => {
    let req: ApiCall = new ApiCall('UPDATE_CLIENT_NOTE');
    if (d.type == 'order') {
        req = new ApiCall('UPDATE_CLIENT_ORDER');
        req.putParam('order_id', Number(d.id));
    } else if (d.type == 'supplier_note') {
        req = new ApiCall('UPDATE_SUPPLIER_NOTE');
        req.putParam('id', Number(d.id));
    } else {
        if ((d as ProductNote).bul)
            req.putParam('connected_id', NKTypeConvertor().toKotlinLong((d as ProductNote).bul));
        req.putParam('id', Number(d.id));
    }
    req.putParam('delivery_value', NKTypeConvertor().toKotlinList(collect((d as ProductNote).products, Number(d.entId), true, JSDB().getUser().first.note_price == 1)));

    req.putParam('updatePrice', true);
    const result = await req.execute();
    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    // bytearray

    return deserializeDocument(result.first);

};


export const getAllPaysDetails: (fromDate?: Date, toDate?: Date, ids?: number[], paid?: boolean) => Promise<Payment[]> = async (fromDate, toDate, ids, paid) => {
    const req: ApiCall = new ApiCall('GET_CLIENT_PAY_DETAILS');
    if (ids)
        req.putParam('ids', NKTypeConvertor().toKotlinList(ids));
    if (fromDate)
        req.putParam('fromDate', fromDate);
    if (toDate)
        req.putParam('toDate', toDate);
    if (paid)
        req.putParam('paid', paid);

    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    // bytearray
    if (result.first.size == 0)
        return [];

    return await result.first.toArray().map((p, index) => serializePayment(p, index));
    ;

};

export const updatePayment: (id: number, type: number, method: number, value: number, check_number?: string, details?: string, clear?: boolean, paid_date?: string, bank_id?: string, boolean?: boolean, notes?: string, category?: string) => Promise<PayNote> = async (id, type, method, value, check_number, details, clear, paid_date, bank_id, sup, notes, category) => {
    const req: ApiCall = new ApiCall('CLOSE_PAYMENT');
    req.putParam('id', id);
    req.putParam('method', method);
    req.putParam('type', type);
    req.putParam('value', value);
    if (check_number)
        req.putParam('check_number', (check_number));
    if (details)
        req.putParam('details', details);
    if (clear)
        req.putParam('clear', clear);
    if (paid_date)
        req.putParam('paid_date', (paid_date));
    if (bank_id)
        req.putParam('bank_id', (bank_id));
    if (sup)
        req.putParam('sup', sup);
    if (notes)
        req.putParam('notes', notes);
    if (category)
        req.putParam('category', category);
    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    // bytearray
    return deserializeDocument(result.first);
    ;

};

export const cancelPaymentLine: (id: number, date: Date, method?: number, value?: number, check_number?: string, bank_id?: string, sup?: boolean) => Promise<PayNote> = async (id, date, method, value, check_number, bank_id, sup) => {
    const req: ApiCall = new ApiCall('CANCEL_CLIENT_PAY');
    req.putParam('id', id);
    req.putParam('date', dateObjectToString(date));
    req.putParam('agent', JSDB().currentAgent);
    if (method)
        req.putParam('method', method);
    if (value)
        req.putParam('value', value);
    if (check_number)
        req.putParam('check_number', (check_number));
    if (bank_id)
        req.putParam('bank_id', (bank_id));
    if (sup)
        req.putParam('sup', (sup));
    console.log(req)
    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    // bytearray
    return deserializeDocument(result.first);
    ;

};

export const getClientChecks: (id: number, sup?: boolean) => Promise<Payment | undefined> = async (id, sup) => {

    const req: ApiCall = new ApiCall('GET_CLIENT_CHECKS');

    req.putParam('client_id', id);
    req.putParam('last', 1);
    if (sup)
        req.putParam('sup', true);

    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });

    if (result.first.size > 0) {
        const rows = result.first.toArray();
        for (let index = 0; index < rows.length; index++) {
            try {
                const p = serializePayment(rows[index], index);
                if (p.check != null) return p;
            } catch {
                /* skip a malformed last-cheque row rather than failing the whole memory fill */
            }
        }
    }
    return undefined;

};
export const updateClientPay: (id: number, payNote?: PayNote, tax_note_id?: number, cancel_id?: number, active?: number) => Promise<PayNote> = async (id, payNote, tax_note_id, cancel_id, active) => {
    //FOR NOW DONT USE TAX_NOTE_ID SINCE THE MINUS APPLY FOR BOTH TAX AND REFUND
    const req: ApiCall = new ApiCall('UPDATE_CLIENT_PAY');
    req.putParam('id', id);
    if (payNote)
        req.putParam('paymentsData', NKTypeConvertor().toKotlinList(deserializePaymentsForBackend(payNote.payments)));
    if (payNote && isSupplierDocument(payNote.type)) {
        req.putParam('sup', true);
        if ((payNote as any).date_edit && payNote.date)
            req.putParam('document_date', dateObjectToString(payNote.date));
        if (payNote.comment != null)
            req.putParam('external_details', payNote.comment);
    }
    if (tax_note_id)
        req.putParam('tax_note_id', tax_note_id);
    if (active)
        req.putParam('active', active);
    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    // bytearray
    return await deserializeDocument(result.first);
    ;

};
export const close_all_docs: (docs: ExtendedDocument[]) => Promise<ExtendedDocument[]> = async (docs) => {

    const dvs = docs.filter((d) => d.type == 'delivery_certificate' || d.type == 'supplier_note')
    const docs_new = []
    if (dvs.length > 0) {
        const x = await close_all_dv(dvs)
        docs_new.push(...x)
    }

    const tns = (docs.filter((d) => d.type == 'invoice' || d.type == 'refund'))

    if (tns.length > 0) {
        const x = await close_all_tn(tns)
        docs_new.push(...x)
    }
    return docs_new;
    ;

};
export const close_all_dv: (d: ExtendedDocument[]) => Promise<ExtendedDocument[]> = async (d) => {
    let req: ApiCall = new ApiCall('UPDATE_ALL_CLIENT_NOTE');
    if (d[0].type == 'delivery_certificate') {

        const docs = d.filter((doc) => doc.status == 'open' && doc.type == 'delivery_certificate');
        req.putParam('delivery_ids', NKTypeConvertor().toKotlinList(docs.map((p) => p.id)));
        req.putParam('paids', NKTypeConvertor().toKotlinList(docs.map((p) => 1)));

    } else {
        const docs = d.filter((doc) => doc.type == 'supplier_note');
        req = new ApiCall('CLOSE_SUPPLIER_NOTES');
        req.putParam('ids', NKTypeConvertor().toKotlinList(docs.map((p) => p.id)));
    }

    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    // bytearray

    return await docResultsDeserialize(result.first);
    ;

};
export const close_all_tn: (d: ExtendedDocument[], sup?: boolean) => Promise<ExtendedDocument[]> = async (d, sup) => {
    let req: ApiCall = new ApiCall('UPDATE_ALL_CLIENT_TAX_NOTE');
    const docs = d.filter((doc) => doc.status != 'closed' && ((!sup && (doc.type == 'invoice' || doc.type == 'refund')) ||
        (sup && (doc.type == 'sup_invoice' || doc.type == 'sup_refund'))));
    if (docs.length == 0)
        return d

    req.putParam('ids', NKTypeConvertor().toKotlinList(docs.map((p) => p.id)));
    req.putParam('types', NKTypeConvertor().toKotlinList(docs.map((p) => p.nkObject?.type ?? 0)));
    req.putParam('active_state', NKTypeConvertor().toKotlinList(docs.map((p) => 2)));
    req.putParam('value_left', NKTypeConvertor().toKotlinList(docs.map((p) => 0)));
    if(sup)
        req.putParam('sup', true);

    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    // bytearray

    return await docResultsDeserialize(result.first);
    ;

};
export const update_all_tn: (d: any[], sup?: boolean) => Promise<ExtendedDocument[]> = async (d, sup) => {
    let req: ApiCall = new ApiCall('UPDATE_ALL_CLIENT_TAX_NOTE');

    req.putParam('ids', NKTypeConvertor().toKotlinList(d.map((p) => p.id)));
    req.putParam('types', NKTypeConvertor().toKotlinList(d.map((p) => p.type == 'invoice' ? 0 : 2)));
    if (d.every((p) => p.status))
        req.putParam('active_state', NKTypeConvertor().toKotlinList(d.map((p) => docStatusToNum(p.status))));
    if (d.every((p) => p.open_tn != undefined)) {
        const data = d.map((p) => {
            // Carteset stores refunds as negative; API expects a non-negative remaining amount
            const value = Math.max(0, Math.min(Math.abs(Number(p.value_tn)), Math.abs(Number(p.open_tn))))
            let status = docStatusToNum(p.status)
            // Fully paid remaining must close both "open" and "partly_closed"
            if (value <= 0.01)
                status = 2
            else if (value > 0)
                status = 1


            return {value: value, status: status}

        });
        req.putParam('value_left', NKTypeConvertor().toKotlinList(data.map((p) => p.value)));
        req.putParam('active_state', NKTypeConvertor().toKotlinList(data.map((p) => p.status)));
    }

    if (d.every((p) => p.comment))
        req.putParam('external_details', NKTypeConvertor().toKotlinList(d.map((p) => p.comment)));
    if(sup)
        req.putParam('sup', true);
    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    // bytearray

    return await docResultsDeserialize(result.first);
    ;

};
export const all_dvs_printed: (d: ExtendedDocument[]) => Promise<ExtendedDocument[]> = async (d) => {
    const isTax = (p: ExtendedDocument) =>
        p.type === 'invoice' || p.type === 'tax_invoice' || p.type === 'refund'
        || p.type === 'sup_invoice' || p.type === 'sup_tax_invoice' || p.type === 'sup_refund';
    const isDv = (p: ExtendedDocument) =>
        p.type === 'delivery_certificate' || p.type === 'supplier_note';
    const taxDocs = d.filter(isTax);
    const dvDocs = d.filter((p) => isDv(p) || !p.type);

    const out: ExtendedDocument[] = [];

    if (dvDocs.length > 0) {
        const req: ApiCall = new ApiCall('UPDATE_ALL_CLIENT_NOTE');
        req.putParam('delivery_ids', NKTypeConvertor().toKotlinList(dvDocs.map((p) => p.id)));
        req.putParam('pdf', NKTypeConvertor().toKotlinList(dvDocs.map(() => 1)));

        const result = await req.execute();

        if (result == null || result.second.name !== 'SUCCESS')
            return new Promise((resolve, reject) => {
                reject(Error);
            });
        out.push(...await docResultsDeserialize(result.first));
    }

    if (taxDocs.length > 0) {
        const taxType = (p: ExtendedDocument) => {
            if (p.type === 'invoice' || p.type === 'sup_invoice') return 0;
            if (p.type === 'tax_invoice' || p.type === 'sup_tax_invoice') return 1;
            return 2;
        };
        const req: ApiCall = new ApiCall('UPDATE_ALL_CLIENT_TAX_NOTE');
        req.putParam('ids', NKTypeConvertor().toKotlinList(taxDocs.map((p) => p.id)));
        req.putParam('types', NKTypeConvertor().toKotlinList(taxDocs.map(taxType)));
        req.putParam('pdf', NKTypeConvertor().toKotlinList(taxDocs.map(() => 1)));
        if (taxDocs.some((p) => p.type === 'sup_invoice' || p.type === 'sup_tax_invoice' || p.type === 'sup_refund')) {
            req.putParam('sup', true);
        }

        const result = await req.execute();

        if (result == null || result.second.name !== 'SUCCESS')
            return new Promise((resolve, reject) => {
                reject(Error);
            });
        out.push(...await docResultsDeserialize(result.first));
    }

    return out;
};
export const refreshDocsCall: (ids: number[], types: number[], offline?: boolean, full?: boolean) => Promise<ExtendedDocument[]> = async (ids, types, offline, full) => {
    const req: ApiCall = new ApiCall('REFRESH_DOCS');


    req.putParam('documents', NKTypeConvertor().toKotlinList(ids));
    req.putParam('types', NKTypeConvertor().toKotlinList(types));

    if (offline)
        req.putParam('offline', true);
    if (full)
        req.putParam('full', full);
    console.log(req)
    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });

    return docResultsDeserialize(result.first)!;
};
export const cancelCustomerDocuments: (d: ExtendedDocument, date?: Date) => Promise<ExtendedDocument> = async (d, date) => {
    const req: ApiCall = new ApiCall('ACTIVE_DOCUMENTS');
    const action = d.status === 'open' || d.status=="partly_closed";
    req.putParam('date', dateObjectToString(date ?? d.date));
    req.putParam('doc', d.nkObject);
    req.putParam('active', action);
    if (d.nkObject?.agent) {
        req.putParam('agent', d.nkObject?.agent);
    } else {
        req.putParam('agent', JSDB().currentAgent);
    }


    if (d.nkObject?.increase_id != undefined) {
        req.putParam('increase_id', d.nkObject?.increase_id)
    } else if (JSDB().curUser?.increase_id) {
        req.putParam('increase_id', JSDB().curUser.increase_id)
    }
    console.log(req)
    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });

    return deserializeDocument(result.first)!;
};
export const createNewInventory: (toDate, pds) => Promise<ExtendedDocument[]> = async (toDate, pds) => {
    const req = new ApiCall('NEW_CLIENT_ORDER');
    req.putParam('date', dateObjectToString(toDate));
    req.putParam('delivery_value', pds);
    req.putParam('sup_delivery_value', NKTypeConvertor().toKotlinList([]));
    req.putParam('ent_id', Number(-3));
    req.putParam('agent', JSDB().currentAgent)
    req.putParam('date_issued', JSDB().getDatesManipulator().dateNow());
    console.log(req)
    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });

    return docResultsDeserialize(result.first);
};
/** Timeout for a single order date-change / duplicate call (ms). */
export const ORDER_DUP_TIMEOUT_MS = 60000;

export const changeAllOrderNoteDate: (ids, date, dup, timeoutMs?: number) => Promise<ExtendedDocument[]> = async (ids, date, dup, timeoutMs = ORDER_DUP_TIMEOUT_MS) => {
    const req: ApiCall = new ApiCall('UPDATE_ALL_CLIENT_ORDER');

    req.putParam('order_ids', NKTypeConvertor().toKotlinList(ids));
    req.putParam('date', dateObjectToString(date));
    if (dup)
        req.putParam('dup', dup);

    let result;
    try {
        result = await req.execute(undefined, undefined, timeoutMs);
    } catch (e: any) {
        const msg = e?.message || e?.name || req.lastError?.() || 'שגיאה בעדכון הזמנות';
        return Promise.reject(new Error(String(msg)));
    }

    if (result == null || result.second.name !== 'SUCCESS') {
        const msg = req.lastError?.() || result?.second?.name || 'שגיאה בעדכון הזמנות';
        return Promise.reject(new Error(String(msg)));
    }

    return docResultsDeserialize(result.first);
};

/**
 * Persist order-level meta on closed (readonly) orders without rewriting delivery_value:
 * נהג זמני (agent_id), סדר נהגים force_position, and notes.
 */
export const updateClosedOrderMeta: (orderData: OrderData[]) => Promise<ExtendedDocument[]> = async (orderData) => {
    const withOrder = orderData.filter((p) => p.orderId && p.orderId !== '');
    if (withOrder.length === 0) return [];

    const req: ApiCall = new ApiCall('UPDATE_ALL_CLIENT_ORDER');
    req.putParam('order_ids', NKTypeConvertor().toKotlinList(withOrder.map((p) => Number(p.orderId))));
    req.putParam('orderAgents', NKTypeConvertor().toKotlinList(withOrder.map((p) => p.orderDriver ?? '')));
    req.putParam('forcePositions', NKTypeConvertor().toKotlinList(
        withOrder.map((p) => (p.force_position_on && p.driver_position != undefined ? Math.round(Number(p.driver_position)) : -1))
    ));
    req.putParam('notes', NKTypeConvertor().toKotlinList(withOrder.map((p) => p.notes ?? '')));
    req.putParam('notes2', NKTypeConvertor().toKotlinList(withOrder.map((p) => p.notes2 ?? '')));
    req.putParam('notes3', NKTypeConvertor().toKotlinList(withOrder.map((p) => p.notes3 ?? '')));
    req.putParam('notes4', NKTypeConvertor().toKotlinList(withOrder.map((p) => p.notes4 ?? '')));
    req.putParam('notes5', NKTypeConvertor().toKotlinList(withOrder.map((p) => p.notes5 ?? '')));
    req.putParam('row_versions', NKTypeConvertor().toKotlinList(withOrder.map((p) => {
        const v = Number(p.row_version ?? p.nkObject?.rowVersion?.() ?? p.nkObject?.row_version ?? 0);
        return Number.isFinite(v) ? v : 0;
    })));

    const result = await executeOrderSave(req);
    return docResultsDeserialize(result.first);
};
export const cancelOrderNote: (ids) => Promise<ExtendedDocument[]> = async (ids) => {
    const req: ApiCall = new ApiCall('UPDATE_ALL_CLIENT_ORDER');

    req.putParam('order_ids', NKTypeConvertor().toKotlinList(ids));
    const status = ids.map((p) => 'מבוטלת');
    req.putParam('status', NKTypeConvertor().toKotlinList(status));
    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    return docResultsDeserialize(result.first);
};

export const prepareCustomerCarteset: (fromDate: Date, toDate: Date, cid: number) => Promise<CartesetDataHolder[] | null> = async (fromDate, toDate, cid) => {
    const req: ApiCall = new ApiCall('CALCULATE_CLIENT_DEBT_TILL_NOW');


    req.putParam('fromDate', dateObjectToString(fromDate));
    req.putParam('toDate', dateObjectToString(toDate));
    if (cid)
        req.putParam('id', cid);

    const result = await req.execute();


    if (result == null || result.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    return deserializeCarteset(JSDB().getClient(Number(cid)).first);

};

export const calculateOptimized: (fromDate: Date | null | undefined, toDate: Date, cid: number, sup?: boolean) => Promise<number | null> = async (fromDate, toDate, cid, sup) => {
    const req: ApiCall = new ApiCall(sup ? 'GET_SUP_OPTIMIZED_CARTESET_VALUE' : 'OPTIMIZED_CARTESET_VALUE');


    // req.putParam('fromDate', dateObjectToString(fromDate));
    req.putParam('toDate', dateObjectToString(toDate));
    if (cid)
        req.putParam('ids', NKTypeConvertor().toKotlinList([cid]));


    const result = await req.execute();


    if (result == null || result.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });

    const entity = sup ? JSDB().getSupplier(Number(cid)).first : JSDB().getClient(Number(cid)).first;
    const wall = entity?.debtWall;
    if(wall){
        return wall.moneyOut - wall.moneyIn
    }
    return null

};


export const getClientsDaily: (fromDate: Date, toDate: Date, cid?: number, day?: number, specific_driver?: number[], specific_collector?: number[], ids?: number[]) => Promise<any[] | null> = async (fromDate, toDate, cid, day, specific_driver, specific_collector, ids) => {
    const req: ApiCall = new ApiCall('GET_CLIENT_DAILY');

    req.putParam('date', dateObjectToString(fromDate));
    if (cid)
        req.putParam('id', cid);
    if (ids)
        req.putParam('ids', NKTypeConvertor().toKotlinList(ids));
    if (day)
        req.putParam('day', day);
    if (specific_driver && specific_driver.length > 0)
        req.putParam('driver_ids', NKTypeConvertor().toKotlinList(specific_driver));
    if (specific_collector && specific_collector.length > 0)
        req.putParam('collector_ids', NKTypeConvertor().toKotlinList(specific_collector));
    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    if (result.first.size > 0) {
        return result.first.toArray();
    }
    return [];
};
export const newAllDaily: (date: Date, orderData: ICustomer[], activeState: OrderActiveState) => Promise<boolean> = async (date, orderData, activeState) => {
    const req: ApiCall = new ApiCall('NEW_CLIENT_ALL_DAILY');
    const d = dateObjectToString(date);

    if (activeState.date)
        req.putParam('date', d);
    if (activeState.day != -1)
        req.putParam('day', activeState.day);
    const data = orderData.map((p, i) => deserializeCustDataToClientDaily(p, p.driver_position ?? 0, p.collector_position ?? 0, d));

    req.putParam('data', NKTypeConvertor().toKotlinList(data));
    const result = await req.execute();


    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });

    return true;

};
export const cancelAllDvs: (dvs: number[]) => Promise<any[] | ExtendedDocument[] | null> = async (dvs) => {

    const req: ApiCall = new ApiCall('UPDATE_ALL_CLIENT_NOTE');
    req.putParam('delivery_ids', NKTypeConvertor().toKotlinList(dvs));
    req.putParam('actives', NKTypeConvertor().toKotlinList(dvs.map((p) => 0)));

    const result = await req.execute();


    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });


    return docResultsDeserialize(result.first);

};
export const newAllDailyNew: (date: Date, orderData: OrderData[], activeState: OrderActiveState,toDate?:string) => Promise<boolean> = async (date, orderData, activeState,toDate) => {
    const d = dateObjectToString(date);
    const req: ApiCall = new ApiCall('NEW_CLIENT_ALL_DAILY');
    if (activeState.date)
        req.putParam('date', d);
    if (activeState.day != -1)
        req.putParam('day', activeState.day);

    const data = orderData.map((p) => deserializeOrderDataToClientDaily(p, (toDate && p.date)? p.date : d, activeState.day));
    req.putParam('data', NKTypeConvertor().toKotlinList(data));
    const result = await req.execute();


    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });


    return true;

};

export const newBase: (d: any) => Promise<boolean> = async (d) => {

    const req: ApiCall = new ApiCall('CHANGE_BASE_AMOUNTS');
    // data c_id,p_id, amount, day? , algo ?


    const data = d.map((p) => JSDB().createBaseData(p.c_id, p.p_id, p.amount, p.day));
    req.putParam('data', NKTypeConvertor().toKotlinList(data));
    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });

    return true;

};
export const updateDriver: (id, driver, all_base: boolean, date?: string) => Promise<boolean> = async (id, driver, all_base, date) => {
    const req: ApiCall = new ApiCall('UPDATE_DRIVER');
    req.putParam('id', id);
    req.putParam('driver', driver);
    req.putParam('all_base', all_base);
    if (date)
        req.putParam('fromDate', date);
    const result = await req.execute();
    if (result == null || (result.name !== 'SUCCESS' && result.name !== 'ERROR_EMPTY_NEW'))
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    return true;
};
export const clearCarteset: (id, date, sup) => Promise<boolean> = async (id, date, sup) => {
    const req: ApiCall = new ApiCall('CLEAR_CARTESET');
    req.putParam('id', id);
    req.putParam('date', dateObjectToString(date));
    if (sup)
        req.putParam('sup', sup);

    const result = await req.execute();
    if (result == null || (result.name !== 'SUCCESS'))
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    return true;
};
export const storeNextLoad: (data, date) => Promise<string> = async (data, date) => {
    const req: ApiCall = new ApiCall('STORE_NEXT_LOAD');
    req.putParam('data', NKTypeConvertor().toKotlinList(data.map((d) => NKTypeConvertor().toKotlinList((d.map((p) => String(p)))))));
    req.putParam('date', dateObjectToString(date));
    console.log(req)
    const result = await req.execute();
    if (result == null || (result.second.name !== 'SUCCESS'))
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    console.log(result)
    return (result.first);
};

export const productsFromNotes: (doc: TaxNote) => IItem[] = async (doc) => {
    const ids = doc.deliveryCertificatesIds.map((d) => Number(d))
    if (ids.length == 0)
        return []

    const req: ApiCall = new ApiCall('TAX_NOTE_EXPLAIN');
    req.putParam('ids', NKTypeConvertor().toKotlinList(ids));
    if (isSupplierDocument(doc.type))
        req.putParam('sup', true)

    const result = await req.execute();

    if (result == null || (result.second.name !== 'SUCCESS'))
        return new Promise((resolve, reject) => {
            reject(Error);
        });

    const ret = result.first
    if (ret.size == 0)
        return []
    const sup = isSupplierDocument(doc.type)
    const client = sup ? JSDB().getSupplier(Number(doc.entId)).first : JSDB().getClient(Number(doc.entId)).first
    return ret.toArray().map((d) => {
        const product = sup ? JSDB().getSupplierProduct(d.id).first : JSDB().getClientProduct(d.id).first
        return {
            discount: d.discount,
            quantityReturns: d.returns,
            totalPrice: roundDecimals((client.include_tax == 1 ||  client.no_tax_client==1) ? d.price / (1 - d.discount / 100) : d.priceBefore / (1 - d.discount / 100), 3),
            id: d.id,
            external_id: product.external_id,
            name: product.getName(),
            image: '',
            barcode: product.barcode,
            position: product.getPosition(),
            quantity: roundDecimals(d.amount, 3),
            quantitySecond: 0,
            no_tax_product: product.getNoTaxProduct() === 1,
            unit: '',
            in_unit: product.getUnitAmmount(),
            category: product.getCategory(),
            category2: product.getCategory2(),
            available_units: [],
            conversion_ratio: 0,
            price_min: roundDecimals((client.include_tax == 1) ? d.priceMin / (1 - d.discount / 100) : d.priceBeforeMin / (1 - d.discount / 100), 3),
            price_max: roundDecimals((client.include_tax == 1) ? d.priceMax / (1 - d.discount / 100) : d.priceBeforeMax / (1 - d.discount / 100), 3),
            total: roundDecimals((client.include_tax == 1) ? d.total : d.totalBefore, 3),
        }
    })
}

function startOfDayForDv(d: Date): Date {
    const x = new Date(d);
    x.setHours(0, 0, 0, 0);
    return x;
}

export type DvFromOrderOptions = {
    /** Each delivery/invoice uses that order's document date; API gets `dates` + min/max range. */
    useEachOrderDate?: boolean;
};

export const dvFromOrder: (
    date: Date,
    orders: ExtendedDocument[],
    refresh?: boolean,
    opts?: DvFromOrderOptions
) => Promise<any[] | ExtendedDocument[] | null> = async (date, orders, refresh, opts) => {
    const req2: ApiCall = new ApiCall('NEW_ALL_CLIENT_NOTE');
    const dateIssued = (JSDB().getDatesManipulator().dateNow());

    const pds = NKTypeConvertor().toKotlinList(orders.map((p) => (p.nkObject.delivery_info)));
    const ids = NKTypeConvertor().toKotlinList(orders.map((p) => (Number(p.entId))));
    const order_ids = NKTypeConvertor().toKotlinList(orders.map((p) => (p.id)));
    req2.putParam('notes', NKTypeConvertor().toKotlinList(orders.map((p) => p.comment ?? '')));
    req2.putParam('notes2', NKTypeConvertor().toKotlinList(orders.map((p) => p.notes2 ?? '')));
    req2.putParam('notes3', NKTypeConvertor().toKotlinList(orders.map((p) => p.notes3 ?? '')));
    req2.putParam('notes4', NKTypeConvertor().toKotlinList(orders.map((p) => p.notes4 ?? '')));
    req2.putParam('notes5', NKTypeConvertor().toKotlinList(orders.map((p) => p.notes5 ?? '')));
    // req2.putParam('orderAgents', NKTypeConvertor().toKotlinList(orders.map((p) => p.on.orderDriver ?? '')));
    req2.putParam('onlyInsert', true);
    let dateParam: string;
    if (opts?.useEachOrderDate && orders.length > 0) {
        const dayStrs = orders.map((p) => {
            const raw = p.date;
            const day = startOfDayForDv(raw instanceof Date ? raw : new Date(raw as string | number));
            return dateObjectToString(day);
        });
        const sorted = [...dayStrs].sort();
        dateParam = sorted[0];
        req2.putParam('toDate', sorted[sorted.length - 1]);
        req2.putParam('dates', NKTypeConvertor().toKotlinList(dayStrs));
    } else {
        dateParam = dateObjectToString(date);
    }
    req2.putParam('date', dateParam);
    req2.putParam('agent', JSDB().currentAgent);
    req2.putParam('ids', ids);
    req2.putParam('date_issued', dateIssued);
    req2.putParam('pds', pds);
    req2.putParam('order_ids', order_ids);
    req2.putParam('withTaxNotes', true);

    const result2 = await req2.execute();
    if (result2 == null || result2.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
                reject(Error);
            }
        );
    let notes = docResultsDeserialize(result2.first)
    if (refresh) {
        const curdocs = await refreshDocsCall(orders.map((p) => p.id), orders.map((p) => p.nkObject.getConnectedDocType()), false, true)
        curdocs?.forEach((p) => {
            notes.push(p)
        })
    }

    return notes;


}
/**
 * Builds the static_data JSON array string for an order row, or '' when no forced fields are set.
 * Empty business_name/address fields fall back to the client values when the document is rendered.
 */
const buildStaticDataArrayString = (p: OrderData): string => {
    const bn = p.forced_business_name ?? '';
    const addr = p.forced_address ?? '';
    if (!bn && !addr) return '';
    return JSON.stringify([{id: String(p.id ?? 0), business_name: bn, business_id: '', address: addr, phone: ''}]);
};

export type NewAllOrderNoteOptions = {
    preserveOriginalDvLines?: boolean;
    editedOrderKeys?: ReadonlySet<string>;
    /** When false, never attach an existing order id. Used for "הזמנה נוספת" so a client can have a second order. */
    runOver?: boolean;
};

const hasConflictingDuplicatePrices = (deliveryInfo: any): boolean => {
    const signatures = new Map<number, Set<string>>();
    const lines = deliveryInfo?.toArray?.() ?? [];
    lines.forEach((line) => {
        const productId = Number(line.productId);
        const productSignatures = signatures.get(productId) ?? new Set<string>();
        productSignatures.add(`${Number(line.price ?? 0)}|${Number(line.discount ?? 0)}|${Number(line.use_price ?? 0)}`);
        signatures.set(productId, productSignatures);
    });
    return Array.from(signatures.values()).some((productSignatures) => productSignatures.size > 1);
};

/**
 * מוצר אבא לחיוב: when creating a note from order lines, switch each priced child
 * to its billing master and clear embedded price/discount/use_price so the note
 * resolves the master's list price (same as pre-preserveOriginalDvLines behavior).
 * Keeps multi-line structure from preserveOriginalDvLines.
 */
const applyBillingMasterToDvLines = (deliveryInfo: any, clientId: number): any => {
    const lines = deliveryInfo?.toArray?.() ?? [];
    if (!lines.length) return deliveryInfo;
    const client = JSDB().getClient(clientId)?.first;
    const lookupIds = [clientId];
    const masterBranchId = Number(client?.masterBranch?.id ?? 0);
    if (masterBranchId > 0 && masterBranchId !== clientId) lookupIds.push(masterBranchId);

    let changed = false;
    const out = lines.map((line: any) => {
        const productId = Number(line.productId);
        let masterId = 0;
        for (const lid of lookupIds) {
            const m = Number(JSDB().getClientProductAvailable(lid, productId)?.master ?? 0);
            if (m > 0) {
                masterId = m;
                break;
            }
        }
        if (!(masterId > 0) || masterId === productId) return line;
        if (!JSDB().getClientProduct(masterId)?.first) return line;
        changed = true;
        const copy = line.doCopy(masterId);
        copy.price = 0;
        copy.discount = 0;
        copy.use_price = 0;
        if (copy.use_price_tax_note != null) copy.use_price_tax_note = 0;
        return copy;
    });
    return changed ? NKTypeConvertor().toKotlinList(out) : deliveryInfo;
};

export const newAllOrderNote: (date: Date, orderData: OrderData[], withOrder: boolean, activeState: OrderActiveState, dv?: any, old?: boolean, historyState?: boolean,toDate?:Date, options?: NewAllOrderNoteOptions) => Promise<any[] | ExtendedDocument[] | null> = async (date, orderData, withOrder, activeState, dv, old, historyState,toDate, options) => {
    if (orderData.length == 0)
        return [];

    const d = dateObjectToString(date);
    const ret: ExtendedDocument[] = [];

    if (dv) {
        const new_dvs = orderData.map((on, index) => {
            const originalDeliveryInfo = on.nkObject?.delivery_info;
            const productsWereEdited = options?.editedOrderKeys?.has(orderKey(on)) === true;
            if (dv[index] == null
                && options?.preserveOriginalDvLines === true
                && productsWereEdited
                && hasConflictingDuplicatePrices(originalDeliveryInfo)) {
                throw new Error(`לא ניתן להנפיק תעודה להזמנה ${on.orderId}: אותו מוצר מופיע במספר מחירים או הנחות. יש לערוך את שורות המוצר בנפרד.`);
            }
            const useOriginalLines = dv[index] == null
                && options?.preserveOriginalDvLines === true
                && !productsWereEdited
                && originalDeliveryInfo?.size > 0;
            const rawPds = useOriginalLines
                ? originalDeliveryInfo
                : (dv[index] == null)
                    ? deserializeOrderDataToOrder(on)
                    : old ? deserializeDataStructOld(dv[index]) : deserializeDataStruct(dv[index]);
            const billed = applyBillingMasterToDvLines(rawPds, Number(on.id));
            const kept = (billed?.toArray?.() ?? []).filter((pd: any) =>
                pd.value != 0 || pd.wrapped_amount != 0 || pd.returns != 0 || pd.wrapped_amount_return != 0
            );
            return {
                on: on,
                pds: NKTypeConvertor().toKotlinList(kept)
            };
        }).filter((o) => o.pds.size > 0 && !o.on.readonly && (o.on.orderId && o.on.orderId != '') && JSDB().checkValidForDv(o.pds));
        if (new_dvs.length > 0) {
            const req2: ApiCall = new ApiCall('NEW_ALL_CLIENT_NOTE');
            const dateIssued = (JSDB().getDatesManipulator().dateNow());

            const pds = NKTypeConvertor().toKotlinList(new_dvs.map((p) => (p.pds)));
            const ids = NKTypeConvertor().toKotlinList(new_dvs.map((p) => (Number(p.on.id))));
            const order_ids = NKTypeConvertor().toKotlinList(new_dvs.map((p) => (p.on.orderId ? Number(p.on.orderId) : null)));
            req2.putParam('notes', NKTypeConvertor().toKotlinList(new_dvs.map((p) => p.on.notes ?? '')));
            req2.putParam('notes2', NKTypeConvertor().toKotlinList(new_dvs.map((p) => p.on.notes2 ?? '')));
            req2.putParam('notes3', NKTypeConvertor().toKotlinList(new_dvs.map((p) => p.on.notes3 ?? '')));
            req2.putParam('notes4', NKTypeConvertor().toKotlinList(new_dvs.map((p) => p.on.notes4 ?? '')));
            req2.putParam('notes5', NKTypeConvertor().toKotlinList(new_dvs.map((p) => p.on.notes5 ?? '')));
            req2.putParam('orderAgents', NKTypeConvertor().toKotlinList(new_dvs.map((p) => p.on.orderDriver ?? '')));
            if(toDate){
                req2.putParam('dates', NKTypeConvertor().toKotlinList(new_dvs.map((p) => (p.on.date && p.on.date!='')? p.on.date: dateObjectToString(date))));
            }
            req2.putParam('date', d);
            if(toDate)
            req2.putParam('toDate', dateObjectToString(toDate));

            req2.putParam('agent', JSDB().currentAgent);
            req2.putParam('ids', ids);
            req2.putParam('date_issued', dateIssued);
            req2.putParam('pds', pds);
            req2.putParam('order_ids', order_ids);
            req2.putParam('withTaxNotes', true);
            req2.putParam('onlyInsert', true);
            const round = parseInt(localStorage.getItem('roundTax') ?? '0') == 1
            req2.putParam('round', round);
            const result2 = await req2.execute();
            if (result2 == null || result2.second.name !== 'SUCCESS')
                new Promise((resolve, reject) => {
                    reject(Error);
                });
            const notes = await docResultsDeserialize(result2.first);
            ret.push(...notes);
        }

    }
    if (withOrder) {
        if (!dv) {
            const orderDataFiltered = orderData;
            if (orderDataFiltered.length > 0) {
                const req2: ApiCall = new ApiCall('NEW_ALL_CLIENT_ORDER');
                req2.putParam('date', d);
                req2.putParam('agent', JSDB().currentAgent);
                req2.putParam('ids', NKTypeConvertor().toKotlinList(orderDataFiltered.map((p) => Number(p.id))));
                const order_ids = NKTypeConvertor().toKotlinList(orderDataFiltered.map((p) => (p.orderId && p.orderId != '' ? Number(p.orderId) : null)));
                req2.putParam('order_ids', order_ids);
                if (options?.runOver === false) {
                    req2.putParam('run_over', false);
                }
                if (activeState.day !== -1) {
                    req2.putParam('day', activeState.day);
                }

                const data2 = orderDataFiltered.map((p) => deserializeOrderDataToOrder(p));
                const categories = orderDataFiltered.map((p) => p.category ?? '');
                const status = orderDataFiltered.map((p) => p.status ?? '');

                req2.putParam('notes', NKTypeConvertor().toKotlinList(orderDataFiltered.map((p) => p.notes ?? '')));
                req2.putParam('notes2', NKTypeConvertor().toKotlinList(orderDataFiltered.map((p) => p.notes2 ?? '')));
                req2.putParam('notes3', NKTypeConvertor().toKotlinList(orderDataFiltered.map((p) => p.notes3 ?? '')));
                req2.putParam('notes4', NKTypeConvertor().toKotlinList(orderDataFiltered.map((p) => p.notes4 ?? '')));
                req2.putParam('notes5', NKTypeConvertor().toKotlinList(orderDataFiltered.map((p) => p.notes5 ?? '')));
                req2.putParam('notes6', NKTypeConvertor().toKotlinList(orderDataFiltered.map((p) => p.notes6 ?? '')));
                req2.putParam('notes7', NKTypeConvertor().toKotlinList(orderDataFiltered.map((p) => p.notes7 ?? '')));
                req2.putParam('notes8', NKTypeConvertor().toKotlinList(orderDataFiltered.map((p) => p.notes8 ?? '')));
                req2.putParam('notes9', NKTypeConvertor().toKotlinList(orderDataFiltered.map((p) => p.notes9 ?? '')));
                req2.putParam('notes10', NKTypeConvertor().toKotlinList(orderDataFiltered.map((p) => p.notes10 ?? '')));
                req2.putParam('orderAgents', NKTypeConvertor().toKotlinList(orderDataFiltered.map((p) => p.orderDriver ?? '')));
                req2.putParam('pds', NKTypeConvertor().toKotlinList(data2));
                req2.putParam('categories', NKTypeConvertor().toKotlinList(categories));
                if(toDate)
                    req2.putParam('toDate', dateObjectToString(toDate));
                req2.putParam('status', NKTypeConvertor().toKotlinList(status));
                if(toDate){
                    req2.putParam('dates', NKTypeConvertor().toKotlinList(orderDataFiltered.map((p) => (p.date && p.date!='')? p.date: date)));
                }
                req2.putParam('ref_ids', NKTypeConvertor().toKotlinList(orderDataFiltered.map((p) => p.ref_id ?? '')));
                // Supply date (תאריך אספקה): empty string keeps existing value on the server.
                req2.putParam('delivery_dates', NKTypeConvertor().toKotlinList(orderDataFiltered.map((p) => p.delivery_date ?? '')));
                // Forced (static_data) fields: JSON array string per row, or '' when none set.
                req2.putParam('static_datas', NKTypeConvertor().toKotlinList(orderDataFiltered.map((p) => buildStaticDataArrayString(p))));
                // Forced route position per row (OrderNote.force_position); -1 = none, use the client daily position.
                req2.putParam('forcePositions', NKTypeConvertor().toKotlinList(orderDataFiltered.map((p) => p.force_position_on && p.driver_position != undefined ? Math.round(Number(p.driver_position)) : -1)));
                req2.putParam('row_versions', NKTypeConvertor().toKotlinList(orderDataFiltered.map((p) => {
                    // A blank order id is an insert. The source row's row_version belongs to the
                    // order that already exists and must not be sent, or the server updates that order.
                    if (!p.orderId) return 0;
                    const v = Number(p.row_version ?? p.nkObject?.rowVersion?.() ?? p.nkObject?.row_version ?? 0);
                    return Number.isFinite(v) ? v : 0;
                })));

                const cc = JSDB().getCollectors().first
                if (cc.size > 0) {
                    const cols = cc.toArray()
                    const collector = orderDataFiltered.map((p) => {
                        const s = []
                        cols.forEach((c) => {

                            if (p[`c_${c.id}`])
                                s.push(JSDB().createNewCollector(c.id, p[`c_${c.id}`]))
                        })
                        if (s.length > 0)
                            return NKTypeConvertor().toKotlinList(s)
                        return undefined

                    })
                    req2.putParam('collection', NKTypeConvertor().toKotlinList(
                        collector
                    ));
                }


                if (historyState)
                    req2.putParam('withHistory', historyState);
                console.log(req2)
                const result2 = await executeOrderSave(req2);
                const orders = await docResultsDeserialize(result2.first);
                ret.push(...orders);
            }

        } else {
            const order_ids = orderData.filter((od) => od.orderId).map((od) => Number(od.orderId));
            if (order_ids.length > 0) {
                const req2: ApiCall = new ApiCall('GET_CLIENT_ORDER');
                req2.putParam('order_ids', NKTypeConvertor().toKotlinList(order_ids));
                const result2 = await req2.execute();

                if (result2 == null || result2.second.name !== 'SUCCESS')
                    return new Promise((resolve, reject) => {
                        reject(Error);
                    });
                const orders = await docResultsDeserialize(result2.first);
                ret.push(...orders);
            }
        }
    }

    return ret;
};

export const allTaxQDeserialize: (ret: any, date: string) => AllTaxNoteHolder[] = (ret, date) => {
    if (!ret?.length) {
        return [];
    }
    return ret.map((t) => {
        try {
            const c = JSDB().getClient(t.client_id).first;
            if (!c) return null;
            const notes = docResultsDeserialize(t.notes);
            const taxNotes = docResultsDeserialize(t.taxNotes);
            let subClient: any[] = [];
            try {
                const clients = t.getClients?.();
                subClient = typeof clients?.toArray === 'function' ? clients.toArray() : [];
            } catch {
                subClient = [];
            }
            return {
                id: c.id,
                nkObject: t,
                type: 'client',
                name: c.getName(),
                bname: c.getBusinessName(),

                driver: c.getDriver()?.user_name ?? '',
                city: c.getCity(date),
                agent: c.getAgent(date),

                amount_dv: t.totalNotesNumber(),
                open_amount_dv: t.openNotesNumber(),
                canceled_amount_dv: t.canceledNotesNumber(),

                open_value_dv: roundDecimals(t.openSum, 2),
                open_tax: roundDecimals(t.openTax, 2),

                total_value_dv: roundDecimals(t.totalNotes, 2),
                total_tax_dv: roundDecimals(t.totalTax, 2),

                amount_tn: taxNotes.length,
                value_tn: roundDecimals(t.totalSum, 2),
                value_tax_tn: roundDecimals(t.totalTaxTn, 2),
                sub: notes,

                subClient,
                dup: false,

            };
        } catch (e) {
            console.log(e);
            return null;
        }
    }).filter(Boolean) as AllTaxNoteHolder[];

};
/** Row refresh after הנפק should not wait forever (כל הפתוחות used to re-scan the whole company). */
export const TAX_NOTE_ROW_REFRESH_TIMEOUT_MS = 60000;

/** Include רשת members so a single-row refresh also loads per-branch split invoices. */
function expandTaxNoteClientIds(ids: number[]): number[] {
    const expanded = new Set<number>();
    ids.forEach((id) => {
        const n = Number(id);
        if (!(n > 0)) return;
        expanded.add(n);
        try {
            const client = JSDB().getClient(n)?.first;
            const branch = Number(client?.branch ?? -1);
            if (branch <= -1) return;
            const members = JSDB().getBranchMembers(branch, false)?.first;
            const arr = members?.toArray?.() ?? [];
            arr.forEach((c: any) => {
                const mid = Number(c?.id);
                if (mid > 0) expanded.add(mid);
            });
        } catch {
            // keep the original id
        }
    });
    return Array.from(expanded);
}

export const getAllTaxNoteQuery: (fromDate: Date, toDate: Date, cid?: number[], citys?: string[], agents?: string[], creators?: string[], allOpen?: boolean, timeoutMs?: number) => Promise<AllTaxNoteHolder[]> = async (fromDate, toDate, cid, citys, agents, creators, allOpen, timeoutMs) => {


    const req = new ApiCall('PREPARE_MASS_TAX_NOTE');
    req.putParam('date', dateObjectToString(toDate));
    req.putParam('fromDate', dateObjectToString(fromDate));
    if (cid) {
        req.putParam('client_ids', NKTypeConvertor().toKotlinList(expandTaxNoteClientIds(cid)));
    }
    if (allOpen)
        req.putParam('allOpen', true);
    // req.putParam('byMoney', true);

    const refreshTimeout = timeoutMs ?? (cid?.length ? TAX_NOTE_ROW_REFRESH_TIMEOUT_MS : undefined);
    const result = await req.execute(undefined, undefined, refreshTimeout);
    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });

    let arr;
    if (result.first.size > 0) {
        arr = result.first.toArray();
    } else {
        return [];
    }

    if (cid?.length) {
        const want = new Set(cid.map(Number));
        arr = arr.filter((t) => want.has(Number(t.client_id)));
    }

    const x = allTaxQDeserialize(arr, dateObjectToString(toDate));
    return x;

};
/** Fallback when an older JS bundle does not yet forward ITA status_msg. */
export const HASH_ISRAEL_GENERIC_ERROR =
    'יתכן כי ח.פ הלקוח שגוי/ חסר או תאריך החשבונית שגוי';

export function hashIsraelErrorText(raw?: unknown): string {
    if (raw == null) return HASH_ISRAEL_GENERIC_ERROR;
    const text = typeof raw === 'string'
        ? raw.trim()
        : String((raw as any)?.message ?? (raw as any)?.status_msg ?? (raw as any)?.text ?? '').trim();
    if (!text) return HASH_ISRAEL_GENERIC_ERROR;
    const name = typeof raw === 'object' && raw ? String((raw as any).name ?? '') : '';
    if (text === name || text === 'ARG_ISSUE' || text === 'ERROR_GENERIC' || text === 'LOGIN_FAILED') {
        return HASH_ISRAEL_GENERIC_ERROR;
    }
    return text;
}

export type HashSignResult = {
    text: string;
    doc: ExtendedDocument | null;
};

export const hashSign = async (id: number, type: number): Promise<HashSignResult | null> => {


    const req = new ApiCall('HASH_ISRAEL_SIGN');
    req.putParam('id', id);
    req.putParam('type', type);


    // req.putParam('byMoney', true);

    const result = await req.execute('LOGIN_FAILED', 'ARG_ISSUE');
    console.log(result)
    if (result.second.name == 'LOGIN_FAILED')
        return null;

    const serverText = typeof result.first?.second === 'string' ? result.first.second.trim() : '';
    return {
        text: serverText,
        doc: result.first.first ? deserializeDocument(result.first.first)! : null
    }

};

export type HashIsraelBulkItem = {
    doc: ExtendedDocument | null;
    error: string;
};

export const hashIsraelSignBulk: (opts: {
    ids?: number[];
    types?: number[];
    fromDate?: string;
    toDate?: string;
    sup?: boolean;
}) => Promise<HashIsraelBulkItem[] | null> = async ({ids, types, fromDate, toDate, sup}) => {
    const req = new ApiCall('HASH_ISRAEL_SIGN_BULK');
    if (ids?.length) {
        req.putParam('ids', NKTypeConvertor().toKotlinList(ids));
    }
    if (types?.length) {
        req.putParam('types', NKTypeConvertor().toKotlinList(types));
    }
    if (fromDate) {
        req.putParam('fromDate', fromDate);
    }
    if (toDate) {
        req.putParam('toDate', toDate);
    }
    if (sup) {
        req.putParam('sup', true);
    }

    const result = await req.execute('LOGIN_FAILED', 'ARG_ISSUE');
    if (result.second.name === 'LOGIN_FAILED') {
        return null;
    }

    const list = result.first?.size > 0 ? result.first.toArray() : [];
    return list.map((item: { first: any; second: string }) => ({
        doc: item.first ? deserializeDocument(item.first) : null,
        error: item.second ?? '',
    }));
};

export const hashIsraelToken: (token) => Promise<boolean> = async (token) => {

    const req = new ApiCall('HASH_ISRAEL_TOKEN');
    req.putParam('token', token);


    // req.putParam('byMoney', true);

    const result = await req.execute();
    if (result == null || result.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });

    return true;

};
export const hashIsraelRefresh: () => Promise<boolean> = async () => {

    const req = new ApiCall('REFRESH_HASH_ISRAEL');



    // req.putParam('byMoney', true);

    const result = await req.execute();
    if (result == null || result.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });

    return true;

};
export const whatsappRefresh: (agent?: string) => Promise<boolean> = async (agent?: string) => {

    const req = new ApiCall('RESET_WHATSAPP_API');
    if (agent)
        req.putParam('agent', agent);



    // req.putParam('byMoney', true);
    console.log(req)
    const result = await req.execute();
    if (result == null || result.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });

    return true;

};
export const splitDocsBy: (date: Date, docs: ExtendedDocument[], users, orderType, dailyG) => any = (date, docs, users, orderType, dailyG) => {
    const g = {}
    switch (orderType) {
        case "pOrder":
        case "driver":
            const u = groupBy(users.filter((u) => u.isDriver()), (item) => item.id);
            docs.forEach((d) => {
                const driverId = dailyG[Number(d.entId)]?.[0]?.driver_id ?? undefined
                const driver = u[driverId]?.[0]?.user_name

                if (!g[driver])
                    g[driver] = []
                g[driver].push(d)


            })
            break
        case "collector":
            const u2 = groupBy(users.filter((u) => u.isCollector()), (item) => item.id);
            docs.forEach((d) => {
                const driverId = dailyG[d.entId]?.[0]?.collector_id ?? undefined
                const driver = u2[driverId]?.[0]?.user_name

                if (!g[driver])
                    g[driver] = []
                g[driver].push(d)


            })
            break

        case "agent":

            docs.forEach((d) => {
                const agent = JSDB().getClient(Number(d.entId)).first.getAgent()
                if (!g[agent])
                    g[agent] = []
                g[agent].push(d)

            })
            break
        default:
            break

    }
    return g
}

export const sortPlanned: (date: Date, planned: ExtendedDocument[], user, orderType, dailyG) => ExtendedDocument[] = (date, planned, user, orderType, dailyG) => {

    switch (orderType) {
        case "driver":
            return planned.sort((a, b) => {
                const a_position = dailyG[Number(a.entId)]?.[0]?.position ?? 1000000
                const b_position = dailyG[Number(b.entId)]?.[0]?.position ?? 1000000
                return a_position - b_position
            })

        case "collector":
            return planned.sort((a, b) => {
                const a_position = dailyG[Number(a.entId)]?.[0]?.position_col ?? 1000000
                const b_position = dailyG[Number(b.entId)]?.[0]?.position_col ?? 1000000
                return a_position - b_position
            })

        case "agent":
            return planned.sort((a, b) => {
                const a_position = JSDB().getClient(Number(a.entId))?.first?.position ?? 1000000
                const b_position = JSDB().getClient(Number(b.entId))?.first?.position ?? 1000000
                return a_position - b_position
            })

        default:
            return planned;

    }
}
export const plannedVActual: (date: Date, planned: ExtendedDocument[], actual: ExtendedDocument[], user, orderType) => Promise<RoutePlan> = async (date, planned, actual, user, orderType) => {

    const d = user
    const name = d?.user_name ?? `ללא ${orderType}`
    const route: RoutePlan = {
        driver: name,
        id: d?.id ?? -1,
        route: [],
        value: 0,
    };
    // Loop over each order for the driver
    const productsMap = groupBy(actual, (item) => `${item.entId}`);
    const orderMap = planned

    let i = 0
    Object.keys(productsMap).forEach((entId, index) => {
        const p = productsMap[entId];
        const distinctVisit = distinctByField(p, (item) => dateObjectToString(item.date)).length
        const first = p[0];
        const amount = p.reduce((sum, x) => sum + x.totalAmount, 0)
        let o
        if (planned.length > index)
            o = orderMap[index]
        i += 1

        const client = JSDB().getClient(Number(first.entId)).first;
        const location = client?.location ?? '';
        const city = client?.city ?? '';
        route.route.push({

            beenPosition: index,
            cname: first.entName,
            cid: Number(first.entId),
            city: city,
            location: location,
            date: dateObjectToString(first.issueDate),
            time: dateTimeObjectToString(first.issueDate).split(" ")[1],
            value: amount,
            docs: p,

            plannedDoc: o, driverId: d?.driverId, driverName: name,
            plannedAmount: orderMap[index]?.count,
            actualAmount: distinctVisit,
            plannedPosition: o ? index : undefined,
            planName: o ? o.entName : '',
            planId: o ? o.entId : -1

        });
    })
    for (; i < orderMap.length; i++) {
        const o = orderMap[i];
        route.route.push({
            cname: "",
            cid: Number(o.entId),
            city: "",
            date: "",
            time: "00:00",
            beenPosition: -1,
            docs: [],
            value: 0,
            driverId: d?.driverId, driverName: name,
            plannedDoc: o,
            plannedAmount: o.count,
            actualAmount: 0,
            plannedPosition: i,
            planName: o.entName,
            planId: o.entId
        });
    }
    route.value = route.route.reduce((sum, x) => sum + x.value, 0)
    return route

}

export const docsToPlannedVsActual: (date: Date, toDate: Date, docs: ExtendedDocument[], actualType: DocumentType[], plannedType: string, orderType, splitByAgent) => Promise<RoutePlan[]> = async (date, toDate, docs, actualType, plannedType, orderType, splitByAgent) => {

    const daily = await getClientsDaily(toDate, toDate, undefined, undefined, undefined, undefined, docs.map((d) => Number((d.entId))))
    const users = JSDB().getAgents().first.toArray()
    const dailyG = groupBy(daily, (item) => item.id);
    const actualDocs = docs?.filter((d) => actualType.includes(d.type)).sort((a, b) => {
        const date1 = a.issueDate
        const date2 = b.issueDate
        if (date1 < date2) {
            return -1;
        } else if (date1 > date2) {
            return 1;
        } else {
            return 0;
        }
    }) ?? []
    const plannedDocs = docs?.filter((d) => d.type == plannedType).sort((a, b) => {
        const date1 = a.issueDate
        const date2 = b.issueDate
        if (date1 < date2) {
            return -1;
        } else if (date1 > date2) {
            return 1;
        } else {
            return 0;
        }
    }) ?? []
    console.log(plannedDocs.filter((d) => d.entId == "1000"))
    let g
    if (splitByAgent) {
        g = groupByUnStr(actualDocs, (item) => item.agent);
    } else {
        g = splitDocsBy(date, actualDocs, users, orderType, dailyG)
    }


    let p
    if (plannedDocs && plannedDocs.length > 0) {
        p = splitDocsBy(date, plannedDocs, users, orderType, dailyG)
    }
    const routes = []
    for (const agent of Object.keys(g)) {
        const curDocs = g[agent];
        const actual = curDocs ?? []
        let planned: ExtendedDocument[] = distinctByFieldWithCount(p?.[agent] ?? [], 'entId')
        const curUser = users.find((d) => {
            return d.user_name == agent.replace(/"/g, '');
        })

        if (plannedType == 'dOrder') {
            planned = sortPlanned(date, [...actual], curUser, orderType, dailyG)
        } else if (orderType == 'pOrder') {
            const plannedMap = new Map(planned.map(item => [item.entId, item]));
            // Create a set of used entIds
            const usedEntIds = new Set<number | string>();
            const activeMap = distinctByField(actual, 'entId')
            // Iterate over actual and get matching item from planned or a blank item
            const orderedPlanned = activeMap.map(doc => {
                if (plannedMap.has(doc.entId)) {
                    usedEntIds.add(doc.entId);
                    return plannedMap.get(doc.entId)!;
                } else {
                    return {
                        id: 0,
                        entId: String(Math.random()),
                        entName: '',
                        entBName: ''
                    };
                }
            });

            // Append remaining items from planned that were not used
            for (let item of planned) {
                if (!usedEntIds.has(item.entId)) {
                    orderedPlanned.push(item);
                }
            }

            planned = orderedPlanned


        } else {

            planned = sortPlanned(date, planned, curUser, orderType, dailyG)
        }


        const route = await plannedVActual(date, planned, actual, curUser, orderType)

        routes.push(route);
    }


    return routes
};
